module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "chap_ttl",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/nav#r_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_vm._v("LONDON, ENGLAND")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext_gudibuk_blsp"
  }, [_c('b', [_vm._v("The Basics: London, the capital of England, is the perfect gateway city for your European adventure. You can fly there directly from pretty much anywhere in America, it’s a five-hour time difference from the East Coast, plus the Brits speak English.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_sydney_tips"
  }, [_vm._v("Um, most of the time. They snog instead of kiss, wear knickers instead of underwear, and spend pounds instead of dollars, so you might not always understand what they’re bloody (bloody = curse word!) talking about.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("I am going to Europe. EUROPE. I am leaving the country. I have never left the country, and now I’m going to at least "), _c('i', [_vm._v("five")]), _vm._v(" countries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If we make it to the gate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Run, Leela, run! Come on! Hurry!” I yell as the two of us charge through the airport. “They just called final boarding!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("“Wait!” she calls back. “I lost a sandal!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turn to see her hopping on one foot. Her bright blue purse is overflowing with a black leather wallet, "), _c('i', [_vm._v("Vogue")]), _vm._v(", "), _c('i', [_vm._v("People")]), _vm._v(", "), _c('i', [_vm._v("EW, Newsweek")]), _vm._v(", hand sanitizer, a small notepad, pencils, her iPhone, and an open metallic makeup bag the size of a microwave. She’s also holding a white plastic bag stuffed with chips, a vitaminwater, and a sandwich.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I dropped the napkins!” she says. “I have to go back for the napkins!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Forget the napkins,” I order. “We don’t have time for napkins. Put your foot back in your shoe and keep moving! I’ll take your food, let’s go!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I grab her bag along with mine and keep running. Instead of a purse, I’m wearing a small black backpack that’s keeping everything in place. My passport. My wallet. My guidebook. Four paperbacks—"), _c('i', [_vm._v("One Day")]), _vm._v(", "), _c('i', [_vm._v("The Paris Wife")]), _vm._v(", "), _c('i', [_vm._v("Daughter of Smoke and Bone")]), _vm._v(", and "), _c('i', [_vm._v("My Brilliant Friend")]), _vm._v("—that all take place in cities I’m planning to visit. Now that it’s summer vacation, I can finally read whatever I want.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When we get to the gate there is only one person in front of us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The board says:")]), _vm._v(" "), _c('p', {
    staticClass: "ext_sng"
  }, [_c('b', [_vm._v("London")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_sng"
  }, [_c('b', [_vm._v("Flight: 401")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_sng"
  }, [_c('b', [_vm._v("Departs: 5:00 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_sng"
  }, [_c('b', [_vm._v("Final Boarding")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We made it!” I say, panting. “I can’t believe it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("Our first almost-delay was when my mother nearly had a panic attack when Leela’s parents picked me up to take us to the airport. She’d come to the driveway to say good-bye, but as I was getting into the car, I saw her eyes glaze over and she seemed very far away. “Mom?” I said, freezing in my spot. “Are you okay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just a bit light-headed,” she answered, retreating toward the house. “Don’t worry about me. Go. Have a safe flight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I felt slightly sick as I watched her close the front door behind her. I wondered: Can I really do this? Can I really leave?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everything okay?” Leela’s dad asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” I said. “Let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So we went.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Traffic was miserable, costing us an extra ten minutes. Then security pulled Leela over to examine her massive makeup bag to make sure she wasn’t breaking any kind of liquids rule.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why do you need so many lipsticks?” I asked her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a ridiculous question.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then why didn’t you pack them in your suitcase?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Most of them "), _c('i', [_vm._v("are")]), _vm._v(" in my suitcase. But I couldn’t pack all of them in there. I was worried they would melt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The final straw was my fault. I insisted on stopping at our terminal’s Fresh Market to get sandwiches. That way we’d be able to eat as soon as we got on the plane, be done before takeoff, and could go straight to sleep. But the line inched "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("forward and we almost missed boarding.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet we made it. We lost the napkins, kept the lipsticks, and we made it. Now, we’re here at the gate. Electricity and excitement rush up my spine—I’m seriously, no joke, actually doing this. I am traveling around Europe with my best friend for four and a half weeks. Holy crap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Boarding pass and passport, please,” the flight attendant says when it’s our turn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here you go,” I say, and hand over my paperwork.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have a good flight, Sydney,” the flight attendant tells me, and hands back my stuff. She turns to Leela.")]), _vm._v(" "), _c('p', {
    staticClass: "int_blsp"
  }, [_vm._v("“Damn,” Leela says. “My boarding pass was with the napkins.”")]), _vm._v(" "), _c('p', {
    staticClass: "ext_gudibuk_blsp"
  }, [_c('b', [_vm._v("Tip: Are you taking a late-night flight? Sleep on the plane! That way you’ll be well rested when you land and ready to hit the ground running.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_sydney_tips"
  }, [_vm._v("Otherwise you’re totally going to be a hot mess by noon.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("Somehow we make it. We spot the pile of napkins and the boarding pass and thirty minutes later, we’re in the air. I take a final bite of my Fresh Market sandwich. “Bathroom, then sleep,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perfect,” Leela says, still chewing. “I’ll watch our stuff.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her stuff is already overflowing from her seatback pocket, and covering both her floor area and mine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("As I make my way toward the back, I can’t believe I actually left. I haven’t been on a plane since I was ten, over nine years ago. I feel free, like a balloon floating through the sky.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The plane rocks to the left.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Free. And slightly untethered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I push away any feelings of uneasiness. The next four and a half weeks are going to be amazing. Incredible. Amazingly incredible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smile at the passengers as I pass them. Hello, little boy. Hello, little girl. Hello, too-skinny mom. Hello, extremely sweaty dad. Hello, cute guy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At first, I don’t recognize him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then I think: His shaggy brown hair, pink cheeks, and lazy smile look familiar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then I realize. MATT. IT’S MATT. "), _c('i', [_vm._v("Leela’s ex-boyfriend MATT")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have never met Matt in person, since Leela met him in Montreal at McGill University, but I recognize him from her Facebook, Snapchat, and Instagram. Selfies of the two of them on the top of a mountain (#climbedit #MontRoyal), pulling all-nighters at the library (#needcoffee), and sharing a plate of french fries, gravy, and cheese curds (#myfirstpoutine).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela introduced us via FaceTime, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’s definitely as cute in real life as he was on the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’s watching something on his iPad. I make a U-turn, go back to our row, and sink into my aisle seat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("“I forgot my parents’ converter,” Leela says. “To plug stuff in.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t worry about that. I bought one and definitely packed it. We can share.” I place my hand on her arm. “But brace yourself, my friend. Matt’s on the plane.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela gasps. “My Matt?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” she finally says when she catches her breath. She drops the rest of her sandwich in her lap. Cheddar. Everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” I repeat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure it’s him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ninety-nine percent sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What row?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thirtyish. He’s wearing a McGill sweatshirt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She buries her face in her hands. “The jackass is on my airplane. What the hell is he doing on "), _c('i', [_vm._v("my")]), _vm._v(" airplane?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Technically the airplane is owned by Delta. Yet operated by Virgin Atlantic.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She doesn’t laugh, even though it was super funny. Okay, maybe not super funny, but definitely a little funny. I would have laughed if she’d said it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He must be in our original seats,” she says. “Thank God I switched mine to be next to you. Thank God. Could you imagine if I had to sit next to him for the entire plane ride? I would die. DIE.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can we not talk about dying when we’re on a plane over "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("the ocean? Thank you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was supposed to cancel his ticket,” she continues. “I told him you were coming with me, and he said he’d go home and get a job in Toronto instead. So why is he here? On my plane? Why would he fly out of Baltimore? He doesn’t even live in Baltimore! I do!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Didn’t you buy the tickets to London together? He probably just kept his. Or maybe he likes the Orioles? I don’t know,” I say. I look out the small window by her head. All I see is blue. “Are you going to go back and yell at him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes! No. I don’t want to see him. I don’t want to talk to him. He knows I’m on the plane. If he wants to see me, he can look for me. He’s an ass.” She jerks up. “Crap. Was he sitting with someone?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know,” I say. “I was so surprised to see him I ran right back here. I never made it to the bathroom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did he notice you?” she asks, worried. “I’m sure he’d recognize you too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, no. He was watching something. I don’t think he saw me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please, please, please go back and see if he’s sitting with anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. Please. I need to know.” She shakes her head. “No way he’s going to Europe by himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He might be,” I say. “Lots of people do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” she says. “He’s not the solo traveler type. Oh God, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("I bet he’s with that chick Ava. She’s probably sitting right next to him. They’re probably feeding each other peanuts. Peanuts! I hate peanuts! Who actually "), _c('i', [_vm._v("eats")]), _vm._v(" the peanuts they give you on airplanes?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They don’t pass out peanuts anymore. Too many allergies. It’s a lawsuit waiting to happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can you just pretend you’re going to the bathroom and check?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I actually "), _c('i', [_vm._v("do")]), _vm._v(" have to go to the bathroom. Still.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perfect. Problem solved.” Leela’s face is desperate, pleading. Her brown eyes look crazed. Even her usual sleek brown hair is mussed, adding to an overall manic look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I unbuckle my seat belt and stand up. We’re in row fourteen. The plane rumbles beneath my feet as I carefully maneuver my way to the back. Twenty-eight. Twenty-nine. Thirty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I look up. And there he is. Still in the aisle seat. Still watching a movie. There’s an older man reading a James Patterson novel to the left of him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not Ava. Small miracle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Matt looks up. Notices me staring. We lock eyes. I look away but it’s too late. Oops.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello, Matthew,” I say. Crap. If he didn’t know who I was at first, I blew it as soon as I said his name. I’m not sure what I’m supposed to do, so I keep moving, using the backs of people’s chairs to wipe off my now-sweaty palms. Luckily "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("there’s no one in the bathroom, so I quickly step in and lock the door behind me.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On my way back, I pretend he doesn’t exist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela is gripping her armrests like the plane is going down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s alone. And he saw me,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do I do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know. Go talk to him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He should come talk to me! He should apologize again! He cheated on "), _c('i', [_vm._v("me")]), _vm._v("! He’s on "), _c('i', [_vm._v("my")]), _vm._v(" plane!” Her voice is a hysterical whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re right,” I say. “He should come talk to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’d better,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I take a deep breath of stale airplane air and wiggle around, trying to get comfortable. It’s tough, since the seat seems to be designed for a preschooler.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela combs her fingers through her long dark hair. “Do I look okay? In case he comes back?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You look great,” I tell her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How’s my lipstick?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Still good,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you, Bite.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I slip off my shoes and try to stretch out my socked toes. “What’s Bite?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This Canadian brand of lipstick I’m obsessed with. I’m applying for an internship there next summer. I love their branding.” Leela is studying marketing at McGill.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("I’m studying English lit at the University of Maryland.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turn to her, realizing the implication of what she just said. “You might stay in Canada next summer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe,” she says. “If I get the internship.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sink back into my seat, feeling something close to relief that I came on this trip. Leela and I "), _c('i', [_vm._v("need")]), _vm._v(" this month together. A friendship can’t survive on childhood memories alone. We have to create new experiences, or the friendship will shrivel up. Like the orchids my dad sent me for my birthday that I completely forgot to water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She points to the screen above us. “Want to watch the movie?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought we were going to sleep?”")]), _vm._v(" "), _c('p', {
    staticClass: "int_blsp"
  }, [_vm._v("“I can’t sleep at a time like this! Also I have to pee. And there’s no way in hell I’m going to the bathroom.”")]), _vm._v(" "), _c('p', {
    staticClass: "ext_gudibuk_blsp"
  }, [_c('b', [_vm._v("Tip: You might want to get CFAR (Cancel for Any Reason) insurance to prepare for the unexpected.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_sydney_tips"
  }, [_vm._v("If you don’t, you’re SOL if your boyfriend hooks up with some random girl and you want a refund on your ticket. Sorry.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("Leela and I had always planned on traveling together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We’d been best friends since the third grade. We picked matching outfits in advance and told people we were twins. Although we were both around the same middle-row-on-picture-day height, I doubt anyone was fooled; she’s Indian "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("and has dark skin and wavy long dark brown hair, and I’m pale with curly medium-brown Jewish-girl hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While other kids played soccer and went to ballet, Leela and I read books. "), _c('i', [_vm._v("The Princess Diaries")]), _vm._v(". "), _c('i', [_vm._v("Anne of Green Gables")]), _vm._v(". But our favorite books took place in England. "), _c('i', [_vm._v("Mary Poppins. Matilda")]), _vm._v(". "), _c('i', [_vm._v("Harry Potter")]), _vm._v(". "), _c('i', [_vm._v("Peter Pan")]), _vm._v(". "), _c('i', [_vm._v("Angus, Thongs and Full-Frontal Snogging")]), _vm._v(". Thongs! Snogging! Ha!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We vowed that one day, when we were older, we would go to England and have our own adventures. London would be so much more fun than Maryland. We would have tea with our pinkies up. We’d go to Buckingham Palace. We’d fly across the city with umbrellas and broomsticks. We’d get engaged in London. Okay, not really, but Leela’s parents had gotten engaged in London and wasn’t that the most romantic thing you’d ever heard?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In middle school, we became obsessed with the Eiffel Tower. We decided we’d go to Paris "), _c('i', [_vm._v("and")]), _vm._v(" London. In high school, Leela studied French and discovered stinky cheese. I read "), _c('i', [_vm._v("Anna and the French Kiss, Just One Day,")]), _vm._v(" and a whole lot about Marie Antoinette.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My cousin Melanie actually backpacked through Europe when she was nineteen. She went for six months. She explained that backpacking through Europe didn’t mean hiking from city to city over mountains like I kind of thought it did. She took trains, and she just carried all her things in "), _c('i', [_vm._v("a backpack")]), _vm._v(" instead of a suitcase. We couldn’t imagine. How would everything fit? I wanted to travel with all my stuff in "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("a backpack! We wanted to backpack through Europe!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even after Leela got into McGill University in Montreal, Canada, and I got a scholarship to go to University of Maryland—which was great because I could live at home, and I felt like I needed to live at home—our plans didn’t change.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re still going to Europe next summer,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course,” I told her, although unlike Leela, I didn’t have a passport.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The night before she left for Canada she said, “We’re still going to Europe this summer,” as she hugged me good-bye.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I promised we would.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela met Matt on the first day of Frosh. That’s the week of drunken debauchery at McGill, the week before school starts. Like in Europe, the drinking age in Montreal is eighteen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the start of the year, Leela and I spoke or texted every day. But as the months went by and I got caught up in classes and studying and parties and driving to and from campus in addition to running around for my mother and my sister, Addison, my response time got slower and slower.")]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Leela: Call me when you can. I miss you!")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Leela: Remember me?")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Leela: Cough, cough, this is still your number, right?")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Me: I’m sorry! I suck! I’m so busy! I love you!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I missed the days when our daily lives were intertwined with school and gossip and hanging out and reading and just watching TV together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("My phone buzzed in late February.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Leela: We’re still going to Europe together, right?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t answer right away. I wanted to go to Europe. Badly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A week later she wrote again.")]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Leela: Hello, stranger. What’s the story for this summer? ARE we going to Europe or not? If yes, we have to get plane ")]), _c('b', [_vm._v("tickets")]), _c('b', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hesitated, my hands on my phone. Our friendship needed this trip. But I couldn’t say yes. I wrote back:")]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("I don’t know.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Leela: Your mom will be fine.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Me: I’m not sure that’s true.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I waited for Leela to respond. She finally texted:")]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Leela: But we’ve been planning this trip FOREVER!!")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Me: I know.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I thought about it. I missed Leela like crazy, but I couldn’t do it. I couldn’t leave my mother for the summer. She "), _c('i', [_vm._v("wouldn’t")]), _vm._v(" be fine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother has a severe anxiety disorder called agoraphobia. People think agoraphobia is a fear of going to public places, but that’s not totally it. Agoraphobics are afraid of being out in public and losing control, so they prefer to stay in places they think of as safe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That’s how my father explained it anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When my little sister and I were still in elementary school, my mom always asked my dad to drive, and we were always the first to leave events, but she still came to our "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("school plays and book fairs and teacher conferences. She worked from home since she’s a children’s book illustrator, but she still left the house. She didn’t love it, but she did it. She and my dad argued all the time. He wanted to go for more dinners, more parties, to meet more people, see more things. She wanted him to slow down and pay attention to his family. He liked to be out. She liked to play Monopoly and watch TV. He wanted to see a marriage counselor. She refused. Her aunt was a therapist, and she thought her aunt was a total kook.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So he went without her. And then when I was in seventh grade, he moved out without her. Without us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After she and my father got divorced, everything went downhill. She was driving us to my middle school’s winter carnival when she had a panic attack. I was in the front, and my sister was in the back seat. We were at a red light when the light turned green and my mom didn’t move.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mom?” I said, and then noticed that her face was white and her hands were shaking. “Mom, are you okay?” She didn’t look okay. She looked like she was about to pass out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The navy Taurus behind us started to honk. Once. Twice. Again. "), _c('i', [_vm._v("HONNNNNK.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What was happening?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have to drive, Mom,” Addison piped up from the back seat. “You can’t b-b-block the road!” Addison had developed a bit of a stammer. Stress, her teacher said. She was only in the fourth grade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("“I . . .” My mom’s voice cracked. “I don’t feel well. I think I’m . . . my chest hurts.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Was she having a heart attack? My own heart started to race.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("HONNNNNNK.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mom? Mom?” Addison cried out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pull into the Dunkin’ Donuts over there,” I said suddenly. I put my hand on top of her arm. It was cold and clammy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She pressed her foot lightly on the gas, crossed the lane, and drove into the parking lot, her hands still gripping the wheel. She put the car into park.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you doing?” Addison asked, her voice rising. “You guys are freaking me out!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does your chest still hurt?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother nodded. She continued to shake. An Adele song played on the radio.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a heart attack. My mother was having a heart attack. I had to do something. What could I do? I needed help. We had to go to the hospital. “Should I . . . should I call an ambulance?” I looked for her purse. Where was her purse? I needed her phone!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shook her head no, but didn’t speak.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mom? Where’s your purse?” I asked. “I need to call an ambulance.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” she said finally. “Don’t. I’m just . . . nervous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What did that mean?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("“Nervous?” Addison asked, and then squeaked out a laugh. “About the winter carnival?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mom closed her eyes. “Syd. Run inside and get me water?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay.” I jumped out of the car and into the cold, relieved to have something constructive to do. I watched them through the store window as I waited in line. My mother’s hands were no longer gripping the steering wheel, and her door was open slightly. She seemed to be taking deep breaths.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A minute later I got back in the car, opened the bottle of water, and handed it to her. “Do you feel better?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She took a long sip. “A little.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s for sure not a heart attack?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A heart attack?” Addison screeched. “You think Mom is having a heart attack?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not having a heart attack,” my mother said quickly. “I’m fine. It’s just a panic attack. I had them when I was younger. Just give me a minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We sat still, the radio continuing to play.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” my mom said after a few songs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We don’t need to go to the carnival,” I said. “Do you want to go home?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No!” Addison squawked. “The carnival has c-c-otton candy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wanted to yell at my sister but didn’t want to stress my mom out even more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("My mom’s lower lip trembled. “I wouldn’t mind lying down.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I put my hand back on her arm. “It’s okay. It’s not that important.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the next few years, my mom wouldn’t drive anywhere unless I was in the passenger seat. She said she liked having me beside her. I calmed her down. Addison and I started taking the school bus to and from school, and I went along with my mom to her appointments, to the mall, to the grocery store, to the pharmacy, to wherever she or my sister needed to go. She was worried that without me there she would have another panic attack, and somehow lose control of the car. I liked knowing that I could help. That I could make my mother feel better.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I was sixteen-and-a-half and I got my license, I started doing most of the driving. That way my mom could relax in the passenger seat and not have to worry about having a panic attack at all. I didn’t mind: I felt needed. I hated that she worried so much, and that her world was getting smaller and smaller, but I was glad I could help and I liked driving and that I basically had my own car. I got to take it to school and wherever I wanted. I also had to pick up Addison after swimming and take my mom to the grocery store.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Until we stopped going to the grocery store. One minute my mom was studying a frozen lasagna in the freezer section of Safeway and the next minute her hands were shaking and the lasagna was on the floor. She was sweating and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("hyperventilating, and she needed me to take her out of there, take her outside right away before she fainted. I grabbed her hands, we left the groceries in the cart and the frozen lasagna on the floor, and I found a bench outside. I told her to take big breaths, that she was going to be okay, that I loved her, and she was going to be fine.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She hasn’t been back to the Safeway since. You can order online from Safeway, and they deliver in an hour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mom was pretty sure she’d have a panic attack at our high school parent-teacher nights, so couldn’t my father go to those, he didn’t live that far away, and then he could tell her what they said? He liked doing stuff like that. Surely he could do at least that after moving out on all of us. He could. And he did.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He also asked her to see a therapist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She said she’d be fine. She’d had a few panic attacks as a teenager, but they had gone away. She ordered some books with relaxation techniques.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When they still didn’t go away, I begged her to at least ask her regular doctor for help. She finally agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I drove her to the appointment and read Ned Vizzini’s "), _c('i', [_vm._v("It’s Kind of a Funny Story")]), _vm._v(" in the waiting room. Her doctor told her that she had to learn to relax, and prescribed an antidepressant. My mom took it every day for a month but said it made her brain cloudy, and then she still had a panic attack when she tried to take us to see a movie. So she stopped taking the pills.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("That was two years ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These days she doesn’t drive. Or go to the grocery store. Or to the movies. Or to shopping malls, or go on trains, or planes, or take cabs. She won’t see another doctor, or try another medication. She doesn’t want to feel drugged out. I’m not sure what else I can do to help her, but it’s hard to watch her in pain. So I do what I can to keep the panic away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mom will sit in the backyard, and even go for walks, but she needs me to be with her when she leaves the house to keep her calm. She doesn’t want to risk panicking and fainting and god forbid hitting her head on the concrete and bleeding all over the sidewalk without anyone to help her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It took me a week to answer Leela’s text about whether or not we were still on. I finally wrote back:")]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("I’m sorry. I can’t.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She wrote back immediately:")]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("BOOOOOO. Are you sure? I really want to go with you.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Me: I want to go with you too. I’M SORRY.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two weeks later she wrote:")]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("How would you feel about me going to Europe with Matt? I would OF COURSE rather go with you. Would you be upset? Be HONEST.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I felt terrible about it, but I couldn’t say that since I wasn’t a selfish asshole. I wrote back:")]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Go for it. You have my blessing.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Leela: Love you. Thanks. Now I just have to convince my parents. . . They like Matt but I’m not sure how they’re going ")]), _c('b', [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  })]), _c('b', [_vm._v("to feel about me traveling with my boyfriend.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela’s parents had always been in favor of our plan to go to Europe since they thought a month of traveling would be good for her. They thought it would teach her to be more independent. Even though she went to school in another country, she still never had to act like a grown-up. She lived in a dorm and had a meal plan. She went to class and came back. Plus, her older sister, Vanya, was a senior at McGill, checking up on her and paving the way. Leela was lucky.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wasn’t sure if I was rooting for her parents to say yes or no.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Three days later Leela wrote:")]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("They said yes! My mom says she likes the idea! She says she feels even safer knowing he’s with me. Sexist but at least they said yes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t respond right away. She was going to Europe without me. She was going to Europe with Matt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela finished her freshman year at McGill in the middle of May and came home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the beginning of June, she stormed into Books in Wonderland, where I work every summer, tears streaking her cheeks. “Matt kissed some girl named Ava at a bar,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took a break and led her outside. We sat on the edge of the sidewalk, our knees hiked up into our chests. “How do you know?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He admitted it. I asked if something was going on, and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("he said yes. Claimed it was a mistake. He didn’t "), _c('i', [_vm._v("mean")]), _vm._v(" for it to happen. He was at a party, and it was an accident. He was freaked out about how serious we were getting. He said he’s still freaked about how serious we’re getting. But come on, how do you accidentally kiss someone?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I considered. “I’m not sure. I think it’s physically impossible. You’d both have to have your mouths open, and you’d have to bump into each other at a very bizarre angle.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She hiccup-laughed. “Exactly. So what am I supposed to do about Europe?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Damn.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No kidding.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Matt and Leela had decided to travel through Europe together for a month. Four and a half weeks, to be exact. They were flying to London on July first and flying out of Rome on August second. They were leaving in three weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you still want to go?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“With him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. Not with him. You can’t go to Europe with a guy who just cheated on you. Do you want to go to Europe by yourself?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, I don’t want to go by myself! I can’t go by myself!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course you can. People travel by themselves all the time. You can go wherever you want. A bookstore in London. A beach in Italy. The Louvre! You’ll eat gelato! Macarons! Stinky cheese!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He doesn’t even like stinky cheese,” she said, sniffing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("“Then he has no taste.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She turned to me. Her expression was hopeful. “Come with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I laughed. “I can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You "), _c('i', [_vm._v("can")]), _vm._v(", Sydney. Please come.” She brightened. “Isn’t Addison working at Sunny’s this summer?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.” She’d gotten a job at the grill by the local pool.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So she’s here. And she has her license now, right? She can help your mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She "), _c('i', [_vm._v("just")]), _vm._v(" got it last month. I’m not sure she feels comfortable driving yet. I think she’d be really mad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ve always tried to shield my sister from the stress of taking care of our mom. I was the one who made sure my mother left the house every day. I was the one who drove her around. In the years right after the divorce, my sister had been too young to help, and I didn’t want to worry her. Besides her stammer, she also started to fall behind in math. Luckily we found tutors and speech specialists who could come to the house.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your mom would be mad?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, Addison would be mad. "), _c('i', [_vm._v("And")]), _vm._v(" my mom. They both would. I can’t go. I’m sorry. I wish I could but I can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can’t? Or won’t?” Leela asked. “Think about it. It’s the trip of a lifetime. And you deserve it, Syd, you really do. You do so much for your family. You need time off. And we never get to see each other anymore. I miss you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I miss you too,” I said. And I hadn’t exactly been the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("world’s greatest friend this year. And Leela needed me. She really did. And she’d always, "), _c('i', [_vm._v("always")]), _vm._v(" been there for me.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe my mom would be okay if my sister helped her? It was only four and a half weeks. I looked back at the bookstore. Eleanor, the owner of Books in Wonderland, wouldn’t mind. She had enough extra staff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I blew out a breath. “How much would the trip cost exactly?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela squeezed my arm. “Not THAT much. We can do it on sixty dollars a day. That’s like two thousand for the whole thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Plus the flight. How much was yours?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eight hundred. Flying into London and flying out of Rome. Are you going to come? Please say you’re going to come!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And how do we get around?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eurail. Seven hundred.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So three thousand five hundred. That’s a lot. But I have some Bat Mitzvah money left. And I’ve been working here for the last month . . . I think I have about three thousand dollars I could scrape together.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe your dad has airline points?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My dad did have airline points. He had a shitload of airline points. He never invited us to stay at his one-bedroom apartment, but he always offered us airline points.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take a vacation,” he’d say. “Have some fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t even have a passport,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("“You can get one fast. I swear. We’ll expedite it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Could I do this? Could I go? The possibility felt like a window being cracked open. I could practically taste the fresh air. The fresh air, gelato, macarons, and stinky cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I bet we could stay with Kat for part of the time,” I said. I’d met Kat at college. She was working at a gallery in Paris for the summer, and her parents had rented her an apartment. “That would save us a few euros.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes!” she said. “We can do this! You’re coming to Europe! Woot!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My cheeks flushed. “Don’t get too excited. I have to talk to my family.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("That night I waited for Addison to get dropped off at home. When she walked into the foyer, her hair was wet and piled on top of her head. We both have our mother’s curly brown hair and round face and our dad’s light brown eyes. Addison’s shorter than I am and more muscular since she swims almost every day and plays third base for the JV girls’ softball team.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She wasn’t the same helpless kid she used to be. She could drive. She had a job. She had even lost her stammer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” I said, lowering my voice since our mom was in the kitchen. “I have a crazy question.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She dropped her knapsack on the floor. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Matt cheated on Leela—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("She made a sour face. “Jerk!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know. But the thing is, now she wants me to go to Europe with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She blinked. Fast. “Oh. Okay. You always wanted to go, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you have the cash?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe. But I would only do it if you think you can handle Mom. Could you? You can drive so I wouldn’t be leaving you stranded. All you have to do is make sure she walks around the block once a day to get some exercise and drive her around if she has to go somewhere. It’s only a month. Four and a half weeks. Would you be okay with that? In theory?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shrugged. “I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah? Think about it. I don’t have to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, you should go. Sounds fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah? And you’d get the car to yourself all summer. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She smiled. “I definitely like the sound of "), _c('i', [_vm._v("that")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If something horrible happens I’ll come back early. I’ll get on the next plane. Swear.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She rolled her eyes. “What do you think is going to happen exactly?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who knows with Mom? She could refuse to leave her bedroom entirely. Or stop showering. I don’t know. Something. If there’s an emergency I’ll come back. Deal?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Deal,” she said. She unzipped her knapsack, took out her "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("wet bathing suit, and uncrumpled it. She didn’t seem worried at all.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hope swelled inside of me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s Mom making for dinner?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Chicken stir fry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you think it’s ready? I’m starving.” She headed into the kitchen, wet bathing suit in hand, not a care in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Okay then.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My heart hammered over dinner. Could I really do this? No. Yes. Should I bring it up? No. Yes. What would my mom say?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My sister helped herself to more chicken and broccoli. “So I hear it’s just us this summer, huh, Mom?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean?” my mother asked, eyebrows scrunching together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Addison made an "), _c('i', [_vm._v("oops")]), _vm._v(" face at me. She clearly hadn’t realized I had not discussed this with Mom yet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now or never.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stared at my plate and the words tumbled out of my mouth like vomit. “Matt cheated on Leela, she’s miserable and needs someone to travel with, I want to go, Dad has airline points, it won’t cost you anything, Addison will help you, is that okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mom put her fork down. “Can you repeat that? Slowly?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("I repeated it. Slowly. Her face got paler and paler with each sentence. Oh, no. Was she going to have a panic attack right at the table?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead of speaking, her shaking hands reached for her glass of water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you hate the idea?” I asked, my shoulders falling. “I don’t have to go. Forget it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She cleared her throat. “No,” she said. “You should go.” She took another sip of water. She seemed to notice her hands were shaking and hid them under the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll be fine,” my sister said, rolling her eyes. “It’s not that big of a deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a big deal. But I wanted to go. And Leela needed me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That night, I lay in my twin bed, the same bed I’d slept in my entire life, staring at the glow-in-the-dark stars I’d stuck to the ceiling when I was eight. Could I really do this? My mom said she’d be fine. My sister said she could handle it. I wanted—desperately—to see Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took out my phone.")]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Me: OK. I’m in. ")])]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("It’s nine p.m. East Coast time and two a.m. London time when Matt finally comes over to talk to Leela. We’re very busy picking at our terrible airplane food, aka our second meal of the night. It’s also the meal we’re supposed to be sleeping through.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi, Leela,” he says. “Can we talk?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("I focus intently on the cold pasta and mushy tomatoes. Mmm. Stale bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela glares at him. “You should have talked to me before getting on this plane.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I tried to find you at the airport. I didn’t see you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Before")]), _vm._v(" the airport. You should have called.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His cheeks turn red. “I’m sorry. I shouldn’t have surprised you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are you doing here, anyway?” she barks. “I thought you weren’t coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know. But I didn’t really have anything else to do this summer, and I already had the ticket, and . . .” His voice trails off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The plane starts to shake. The seat belt sign comes on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“. . . and I wanted to see you, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela stares at her hands and doesn’t respond.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Enjoy the cookies,” he says, and walks back to his seat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I "), _c('i', [_vm._v("am")]), _vm._v(" planning on enjoying my cookie. It’s wrapped in plastic and looks delicious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We wait until we’re sure he’s gone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He wanted to see me?” she squeals. “What does that mean? He wants to get back together?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you want to get back together?” I ask. The possibility of them getting back together hadn’t really occurred to me. If they get back together, what happens to me exactly? Will I have to travel Europe with both of them? I do not want to be a third wheel on my own travel adventure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("“No!” she says. “Of course not. He cheated on me! He’s a jerk!” She wraps a lock of dark hair tightly around her finger. “But do you think he came to Europe to get back together?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I imagine being on a top bunk while the two of them have muffled make-up sex in the bunk bed below me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Did I remember to pack earplugs?")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("“Please put your tray tables away and your seats into the upright position,” the flight attendant announces on the loudspeaker, startling me awake. “It’s now six a.m. and we will be landing shortly. The temperature in London is twenty-one degrees Celsius.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I yawn. I got about an hour of sleep, tops. But I did finish "), _c('i', [_vm._v("One Day")]), _vm._v(" and half of "), _c('i', [_vm._v("The Paris Wife")]), _vm._v(". I’ll probably be an exhausted mess, but it’s okay because I have four and a half weeks—four and a half weeks!—to rest. I have no essays, no midterms, no group projects, no mother and sister to take care of. I am officially on vacation. I haven’t taken an actual vacation since before my parents got divorced. And I’ve never, ever, gone away with Leela. Her family invites me to join them in Naples, Florida, every winter break, but I never wanted to leave my mother. This year Leela brought Matt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I look over to see that Leela is already awake and trying to repack everything that spilled out of her purse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Morning,” I say. “Twenty-one degrees? We’re going to freeze! Just kidding. It’s Celsius! How cute is that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("“Very charming,” Leela says. “That’s about seventy degrees. They use Celsius in Canada too, you know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I open my window cover as the plane descends, not really seeing much. Just clouds. But I know the Thames River and the London Eye and everything else are right below.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the plane touches ground, half the people clap and I join in because, well, why not? We made it, didn’t we? I gather my books, and make sure my passport didn’t somehow slip out and end up under someone else’s seat, and then rummage through Leela’s discarded pillow and blanket in case she forgot anything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are we walking slowly or quickly?” I ask, filing into line.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do we want him to catch up to us or not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh. Not. If he really came to Europe to find me, he can run after me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When we step off the plane, there are hundreds of travelers of all ages walking in different directions, with carry-ons, wheelies, and backpacks. And there are a whole lot of stores I don’t recognize. Boots, which seems like a pharmacy. And WHSmith, which has displays of bestselling books. There is even a cute dark-haired boy studying a paperback. “Leela! They have pharmaceuticals, books, and cute boys here! We’re going to love it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s find a bathroom,” she instructs, not looking around. “Fast.” She didn’t go once the whole plane ride.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("“To the loo!” I say.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t make me laugh, I’ll pee in my pants.” We spot a sign that says “Female Toilet,” and make a run for it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even the bathrooms are different. The toilets are squareish, and there aren’t any visible tanks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you flush?” she asks. “There’s no flusher!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s on the wall!” I call out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I get out, she’s brushing her teeth in the sink. Her hair looks combed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do I have to do that too?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She spits. “No, you’re not about to face an ex-boyfriend.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wouldn’t care if I were. My last relationship was in January and only lasted two months. Theo was an economics major and a friend of Kat’s. I slept with him six times and I thought he was sweet until he started speaking in an Elmo voice and saying things like, “Theo is so sad when Sydney doesn’t sleep over!” and “Theo wants to see Sydney’s house!” Also, while he was a good kisser, he wasn’t great at the sex part. It lasted about fifteen seconds and he hummed the whole time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anyway. Matt was Leela’s first boyfriend. First everything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While she applies one of her seven lipsticks, I take my phone out of my backpack and debate turning it on. I guess I should. To make sure everything is okay at home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A text message pops onto my screen. "), _c('b', [_vm._v("FREE MSG: Your ")]), _c('b', [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  })]), _c('b', [_vm._v("phone number has exceeded $15 in global data charges. Data is $2.05/1MB.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("WTF? Fifteen dollars in global charges? In four seconds? Oops. I forgot to turn on an international plan, and I’m roaming.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Three texts pop onto my screen, too. All from my sister, Addison.")]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("All OK! ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Are you there yet? I can’t find the car keys.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Crap. I turn my phone off in case my bill doubles in the next four seconds. I’ll deal with the car keys and charges later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Syd . . . ” Leela says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah?” I return my phone to my bag.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you know about this?” she asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She turns to me, brown eyes wide. “Is this a surprise?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have no idea what she’s talking about. “Is what a surprise?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did he tell you he was coming? Is this whole thing a big surprise for me? Like my dad surprised my mom?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I suddenly remember that her father surprised her mother at a tea place in London. And then he proposed. Does she think Matt hooking up with Ava was a hoax? That the whole last month was a trick to surprise her in London and propose?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, sweetie,” I say. “No. I’ve never spoken to Matt "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("before today, except with you on FaceTime. I don’t think he’s showing up at the tea place with an engagement ring.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks down. “I didn’t think he was going to "), _c('i', [_vm._v("propose")]), _vm._v(". I just thought maybe he was planning on winning me back and showing up with flowers and telling me he loves me. Do you know he’s never said I love you? Not once.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry,” I say. “But I haven’t talked to him. I swear.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She sighs. “Okay. Just checking.” She repacks her bag and heads out the bathroom door. “Onward.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re in the "), _c('i', [_vm._v("Queen’s")]), _vm._v(" Terminal. The queen’s!” I exclaim, trying to cheer her up. “I love the queen. I want to meet the queen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We probably won’t, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As we make our way to Passport Control, I catch Leela scanning the line for Matt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I give her arm a squeeze.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, it’s our turn to step up to a booth. “Where do you reside?” the man asks. He has a British accent, and I love him immediately. I resist the urge to ask him if he knows Mary Poppins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maryland,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How long are you here for?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re traveling for a month,” I say. “Four and a half weeks. Do you need to know all the countries we’ll be visiting?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” he says, and stamps our passports.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My first stamp. I know I have a dumb smile on my face, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("but I can’t help it. It’s just a little black box that says “Immigration Officer,” the date, and “Heathrow,” but it’s my first international stamp and it’s awesome.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We follow the signs to baggage reclaim. Not claim. Reclaim. Adorable!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you see him?” she asks, clearly trying very hard to not look around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not yet. But he was at the back of the plane.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A few minutes later I spot him by the door. “He’s here,” I say. “He sees us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She freezes but doesn’t give herself away. “What’s he doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Walking toward us. Should I laugh or something? Pretend we’re having a great time? Pretend you’ve just said something incredibly witty?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ha, ha, ha!” I force a massive smile. “We’re having such a great time! You’ve just said something so incredibly witty! Now do you want me to casually leave?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Matt says something to the guy beside him, and I realize that it’s the cute guy I saw looking at the books, and that he must be the person traveling with Matt. They probably met up in the terminal. The guy’s hair is straight and dark brown, almost black, and he’s tall. Taller than Matt, anyway. Square jaw. Dark eyebrows. Perfectly smooth olive skin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’s kind of hot. Actually, he’s really hot. Why have I "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("never seen him in any of Leela’s photos? I’d rather look at him than a plate of poutine.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s with a really hot guy,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Huh?” she asks. “Is it Jackson?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know who Jackson is,” I say. “But maybe?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The guy-who-is-possibly-Jackson spots his backpack—it’s a deep red—at another conveyor belt and hoists it over his shoulder in one swoop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela closes her eyes. “I can’t "), _c('i', [_vm._v("believe")]), _vm._v(" he’s traveling with Jackson.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I know there’s a story here, and I am looking forward to hearing it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Out of the corner of my eye, I spot my spankin’ new backpack and leap over to pick it up. It’s pale blue with black stitching and lots of zippers, and it has adjustable arm straps and a band that I can snap around my waist, which will supposedly help distribute the bag’s weight. Am I really going to wear this on my "), _c('i', [_vm._v("back")]), _vm._v(" for over four weeks? Or is that more of a figure of speech?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Also, now I have two backpacks: the small one I’m already wearing on my back and a huge one. My plan was to roll the small one up and pack it when it wasn’t in use, but I can’t exactly do that here. I’m going to have to wear one on my back and one on my front. That’ll be super attractive. Maybe I’ll wait until Hot Jackson is no longer in the vicinity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello again,” Matt says as the two of them approach us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fancy seeing you here,” Leela replies drily. Her arms are "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("crossed in front of her chest. “Sydney, this is Jackson. Jackson, Sydney. Syd, I believe you already met Matt.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We go way back,” I say. “All the way to row thirty. Hi there, Jackson. We missed you on our flight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I flew from Vancouver,” he says, turning toward me. “But I hear yours was a party.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was definitely wild and crazy,” I say, smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He smiles back, and I realize I am no longer the third wheel. Jackson and I are in this drama together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela shakes her head and glares at Matt. “I can’t believe you’re crashing my trip.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m not sure how I feel about Matt, but I may not mind Jackson crashing my trip.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not crashing,” Matt says. “I’m going to Europe. With Jackson. I already had the ticket. Trust me, I tried really hard to switch the ticket to leave from Toronto, but I couldn’t make it happen. I’m sure our plans will be completely different, so don’t worry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They better be. How long are you staying in London?” Leela asks, eyes narrowed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Four nights.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her jaw clenches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I spot Leela’s suitcase coming our way. She’s using one of those duffel bags on wheels, instead of a backpack. She had decided backpacks were dorky. I completely disagree. Backpacks are awesome.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Leela, your bag,” I say, deciding that their conversation "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_vm._v("could use an interruption.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She twists her head toward the belt and tries to drag it off the conveyor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let me help you,” Matt says, and reaches toward it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t need your help,” she snaps, grabbing it. “I can get along fine without you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, then.” He reaches over to the conveyor and picks up and puts on his own black backpack. Then he walks backward and away from us. “You’re on your own. Have a great trip.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nice meeting you,” Jackson says to me with a half smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You too,” I say, adding a little wave. Good-bye, Hot Jackson, good-bye.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going to kill him,” Leela mutters, turning around. She studies the black bag. “Damn. This isn’t even mine. I got a Canadian bag tag. Help me put it back?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not actually Canadian,” I say, hoisting it back onto the conveyor belt. “You know that, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Europeans like Canadians better than Americans,” she says. “We have to be careful here, you know. I brought one for you, too. It’s in my bag.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We stand side by side watching for her suitcase.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It doesn’t come.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I see Matt and Jackson disappear through customs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Seriously, I am going to kill him,” Leela says. “Maybe the murder laws are different here. Perhaps you’re allowed to kill your ex?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_vm._v("“Probably not in the UK. The Brits are supposed to be uptight.” I smile. “But maybe in France.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We wait for Leela’s bag. And wait some more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All the other bags come through and get picked up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not hers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela’s breathing fast and her jaw is clenched again and I can tell she is about to start crying. “Omigod. I can’t deal. I can’t take it. I can’t handle him being here and losing my luggage. I just can’t. I need my lucky black dress! And my hair dryer!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s going to be fine,” I say. “Let’s go talk to someone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To who?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To them!” I say, pointing to the counter in the corner that says Customer Service. “They will help us! They will find your bag. If not this very moment, then soon, and then they will send it to us. You have a lot of stuff in your carry-on, right? Is it enough to keep you going for a day or so? I saw you brush your hair and teeth so I know you have those. Plus magazines. And makeup.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” she says. “I have those. And an extra pair of undies. And my pills.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What pills? Anything fun?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Birth control pills. You are welcome to party with them all night long.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re still on birth control?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course. I’m not getting off just like that. They make my boobs ginormous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_vm._v("“Do you think they would make my right boob as big as my left?” I ask.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t guarantee that,” she says. “But I appreciate your attempt to make me laugh and forget that I might have to walk around London in my undies.”")]), _vm._v(" "), _c('p', {
    staticClass: "int_blsp"
  }, [_vm._v("“Knickers,” I say. “They’re called knickers here.” I hoist the big bag on my back, and the small one on my front. “Now let’s go get some customer service.”")]), _vm._v(" "), _c('p', {
    staticClass: "ext_gudibuk_blsp"
  }, [_c('b', [_vm._v("Tip: The Tube is the cheapest way to get from Heathrow into London. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_sydney_tips"
  }, [_vm._v("We are sorry to inform you that the Tube is the London subway and not, as we had hoped, a cross-city waterslide.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("Forty-five minutes later, on the other side of customs, Leela is still duffel-bag-less. Customer Service has promised that when they locate it they will have it sent to our hostel. I can only hope we are still in London by then.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I feel slightly brain-dead, so I lead us toward an Italian coffee place called Caffè Nero. We use the pounds we exchanged at home to get us started to buy two cups of Americano and take big, long sips.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ahhhh,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Should we just take a cab?” Leela asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, we shouldn’t,” I say. “A cab will be a fortune. This coffee just cost like four American dollars each and we’re "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_vm._v("supposed to be budgeting. We said we would take the subway. It’s called the Underground here. The Tube! Doesn’t it sound like a waterslide?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How awesome would that be?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We follow the signs to the Underground. There’s an elevator—a lift—that takes us to floor “-1.” Ha! Minus one! You’re so cute, London.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When we get to the ticket machines, I feel a wave of uneasiness. I have no idea what to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What station are you going to?” a man in uniform asks me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank goodness. Help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Covent Garden,” I say. “But I think we’re supposed to get an Oyster card.” I read that in my "), _c('i', [_vm._v("Travel Europe")]), _vm._v(" book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We each put twenty pounds on our cards, which, at the exchange rate of 1.5, cost us like thirty dollars each. I hope that will last the whole time, otherwise we’re never going to be able to do this on sixty dollars a day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mom ordered "), _c('i', [_vm._v("Travel Europe")]), _vm._v(" from Amazon for me, which was pretty sweet of her. Obviously she should have bought it from Books in Wonderland, especially since I get an employee discount, but it wasn’t like she was going to leave the house to visit the store on her own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a trip of a lifetime,” my mom said. “I wish I had done it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She never would have. She hated traveling even when she was my age.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }, [_vm._v("I had done as much planning as I could in the three weeks I’d had. Leela had been kind of a mess after the breakup, so she’d lie on my bed while I looked things up and made reservations. I’d booked the first hostel, plus loosely planned our days, and reserved our train to Paris. There, we’d stay with my friend Kat for five nights. After that, we’d save more money by taking an overnight train to Berlin instead of a day train. After Berlin, we could see what we felt like doing. Maybe Prague, which wasn’t too far from Berlin, and Vienna, and then maybe another overnight to Italy? But we would play it by ear. As I’d told Leela, nothing was set in stone.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re the best,” she’d said, tracing circles into my pillow. “Matt had wanted to just go and figure things out as we went along, but having a plan is so much smarter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t mind,” I said. “I like planning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And anyway, in a way it felt like I was paying Leela back for years of looking out for me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Years.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After my parents’ divorce, she’d cheered me up with funny pictures she’d drawn, and sleepovers and daily calls just to say hi.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On my fourteenth birthday, I insisted my mom take me and Leela and Addison out for Japanese. We never went to restaurants, but it was my birthday. My birthday! I didn’t want to eat dinner at home. I wanted to do something special. After dinner, Leela would stay the night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "title": "42"
    }
  }, [_vm._v("My mom drove. I sat in the passenger seat. Everything was fine.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She had a panic attack while we were eating our sushi.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her hand started shaking while she held the chopsticks. Her face flushed and she was breathing hard and fast like she was running up stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every emotion hit me at once. Worry for my mom. Guilt for forcing her to go out even when I knew she didn’t like to. Embarrassment that this was happening in front of Leela. But I jumped up and waved down the waiter to get water and I rubbed my mom’s back. I was too ashamed to look at Leela. But when Addison started to cry, Leela put her arm around my sister and whispered to her that everything was going to be okay.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later that night, when I turned off the lights, I told Leela the truth. I stared at the glowing stars on my ceiling and let my words just be words floating in the dark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I was finished, she sat up in bed and I could feel her looking at me. “You were so awesome tonight. You took care of everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shrugged but felt pleased. And relieved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I won’t tell anyone,” Leela said. “Not even my mother if you don’t want me to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can tell your mom,” I said. “But, please, no one else.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Afterward, Leela started coming to my house more often.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "title": "43"
    }
  }, [_vm._v("She made sure I always had a way to and from every school play, every school dance, and every birthday party. Leela always, "), _c('i', [_vm._v("always")]), _vm._v(" made sure I was okay.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now I would do the same for her.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("There’s already a train waiting for us since this is the first stop on the Piccadilly Line. I sit. The seats are plush and fuzzy, which seems like the wrong choice. What happens if someone spills something on them? Like an Americano, perhaps? I hold my coffee tightly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I can’t believe I’m here. On a train in London. Holding a coffee. This is crazy. This is amazing. This is scary. What if I get us lost? I look down at the map in my "), _c('i', [_vm._v("Travel Europe")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“First stop, London, here we come!” I say, trying to sound brave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How many days are we staying here again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Five nights,” I say. “Then Paris.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is that enough time?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Travel Europe")]), _vm._v(" says so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughs. “Well, if the guide says it, it must be true.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did I tell you there’s a "), _c('i', [_vm._v("Travel Europe")]), _vm._v(" app too?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you download it yet? It’s only $2.99.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I know I’m doing most of the planning on this trip. But that doesn’t mean I want to deal with "), _c('i', [_vm._v("everything")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Haven’t had a chance,” she says. “An app makes more sense, though. That book looks heavy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44",
      "title": "44"
    }
  }, [_vm._v("“I’m going to rip out the pages when we leave a place,” I say. “To lighten it up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Smart,” she says. “Speaking of leaving places, I’m glad you’re not making me go to Amsterdam.” She makes a face. Amsterdam had been the only must-see for Matt. Since "), _c('i', [_vm._v("Travel Europe")]), _vm._v(" spent a lot of pages describing how the city is famous for sex tourism and drugs, I could see why Leela had been concerned that he’d been a little too excited about the place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We have a packed schedule without Amsterdam,” I say. I flip through all the countries. “There’s so much to see and do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe we should make up our own guide,” Leela says. “"), _c('i', [_vm._v("The American Girls’ Guide to Traveling Around Europe While Avoiding Your Ex")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe just the "), _c('i', [_vm._v("Girls’ Guide to Europe")]), _vm._v(". Snappier.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Definitely,” Leela says. “Where are we getting off again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Covent Garden,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks out the train window. “And you know where we’re going?” Leela asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” I say, but my voice shakes. I look down at the map in my book. “Maybe. I guess we’ll find out.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("When we get out of the train, the line for the lift is really long—and there are no escalators.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s just take the stairs,” I say. “We’ve been sitting forever.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you’re wearing a backpack.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45",
      "title": "45"
    }
  }, [_vm._v("“It’s not that heavy,” I say. The band around the waist really works. It’s pretty smart engineering. “And the line is insane. Is one of the elevators broken? By the time it’s our turn, our four and a half weeks will be up. How many flights of stairs can there be, anyway? How deep underground are we?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It turns out we are very deep underground. After four flights, my heart is pounding. “I bet you’re not so sad about your missing luggage now,” I pant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’d bet right,” she says cheerfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re so not borrowing my underwear.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If we ever get out of here alive, I will buy my own underwear. But can I use your deodorant?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. That’s disgusting. Also there might not be any left by the time we see sunlight. I think I’m going to have to reapply any second.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please let me help you with your bag,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My heart is racing, and I think I might throw up. “Okay,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She takes the back and I take the front. Up. Up. Up. A kid around thirteen passes us and gives me a dirty look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I bet Matt took a cab. You have no idea. His parents pay for everything. Bullshit he couldn’t get a new flight. He better not be at our hostel. He probably won’t be. I’m sure he got something fancy and not a room without its own bathroom. What do you want to do first?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can’t talk,” I huff. “Climbing.” Am I going to pass out? I’m beginning to see spots. I’m not going to faint, am I? "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_46",
      "title": "46"
    }
  }, [_vm._v("“How much farther do you think it is?” I ask Leela.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No idea,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another person pushes past us. “Excuse me?” I ask. “Do you know how many flights are left?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re almost halfway,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My chest hurts. Suddenly the staircase starts to feel even smaller. What is wrong with me?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh, no.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Is this a panic attack?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No, no, no.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am not having a panic attack. I am not. This is not a panic attack. This is just what it feels like to be out of shape and climbing a million stairs while carrying a massive backpack.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Spots crawl across my vision. “I don’t think I can do this,” I admit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you want to go back down?” she asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe,” I say. “Will you hate me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I could never hate you,” she says. “And this weighs a ton.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We return down the stairs and join the now even longer line for the lift.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry about that,” I huff. My breaths are still coming fast. But that was not a panic attack. I’ve seen panic attacks and that was "), _c('i', [_vm._v("not")]), _vm._v(" one. That was just an insane amount of stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No worries, I was getting tired, too.” She shakes her head. “I can’t believe he came with Jackson.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_47",
      "title": "47"
    }
  }, [_vm._v("“So what’s the deal with Jackson?” I ask, picturing him in my mind and enjoying the image.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s not my favorite of Matt’s friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh. Boo. “He was very hot, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. He’s also a bad influence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She rolls her eyes. “He’s kind of a man whore. We were all in the same residence, right? During Frosh I counted the number of girls that came out of his room. Are you ready? Nine. Nine! Frosh was less than a week! And they came out with their shirts on inside out or their hair all messed up, with dopey smiles on their faces. And he just got worse over the year. Plus he was with Matt when he kissed Ava. I bet he was pushing Matt toward her, telling him that she was flirting with him, that he couldn’t spend the whole month depressed about me. Jackson is not a big believer in relationships. I’m sure he’ll try to get Matt to sleep with every girl he meets across the continent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He sounds charming,” I say, pushing the image of Mr. Hotness out of my mind. I do not lust after man whores, no matter how good-looking they are.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another lift fills and closes, and we move up. Still not our turn, though. It’s so dark in here. What happens in a power failure?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh! One night he hooked up with two roommates!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gross. Did they know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes! Sorry, was that not clear? He hooked up with them "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48",
      "title": "48"
    }
  }, [_c('i', [_vm._v("together")]), _vm._v(". They didn’t even like each other. But they both liked him and . . .” Her voice trails off and she shakes her head. “I can’t believe that’s who Matt’s traveling with.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, the elevator doors open, and it’s our turn. We step in with about ten other people, and I end up all the way in the back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s feeling a little crowded in here. I still haven’t gotten my breath fully back from the stairs. How long is this going to take?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re not even that good friends,” Leela continues. “And Matt’s always trying to impress him. He drinks more when Jackson’s around, smokes more. And then he’s a mess. It’s horrible. And embarrassing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The doors open, and I can see light. Hurrah! I readjust the backpack and step outside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh no,” Leela says. “It’s pouring!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At this point, I don’t care if there’s a blizzard. I push my way outside and take a huge, glorious breath of wet London air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“’Allo, London!” I cry. “It’s more of a mist.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I try to take it all in at once. There are tourists looking around and businessmen and women in suits and younger men in tight jeans and women in ballet flats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It smells like exhaust fumes and rain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cars are like regular cars, but fatter and shorter. Smushed. And the cabs are all black.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look! It’s a double-decker bus!” I say, pointing ahead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49",
      "title": "49"
    }
  }, [_vm._v("It really is a double-decker bus. Just like in the movies.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And there’s a red phone booth!” Leela says. “I guess they still use phone booths here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe they just keep them because they’re so cute.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take a picture of me in it!” Leela cries, tossing me her phone. She squeezes inside, and picks up the pay phone. “Omigod, it stinks in here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Smile!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She smiles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Snap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m captioning it ‘London’s Calling,’” she says. “Clever, huh? Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Very clever,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you know which way our hostel is?” Leela asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Um, no,” I say. “I put my book in my backpack. Can you check your phone? You have 3G over here, right? Or whatever they call it in London?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, right! Let me use Google Maps. Thank God I didn’t pack my phone in my luggage.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why would anyone pack their phone in their luggage?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure some people do. Okay, here we go. What’s the name of the hostel again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s called Zuhause.” It’s five minutes from Covent Garden, which I read was a great location. And we have our own room. Not our own bathroom, but our own room. And they had a web special so I got it for only thirty pounds a night, which is fifteen pounds each, which is like twenty-five dollars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_50",
      "title": "50"
    }
  }, [_vm._v("“Oh. Right. Z-o-o house? Like it’s a zoo?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. It’s German for . . . I don’t remember.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So how do you spell it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know. You have the phone.” I try not to sound irritated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t get cranky. I’ll find out.” She spends a few more seconds typing on her iPhone. “It’s this way,” she says, pointing across the street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, let’s go,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Should we stop so I can get some stuff?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can we just check in first? My back is feeling numb.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s cross,” Leela says. She looks left and takes a step into the street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A black cab goes zooming by her from the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look right!” I yell as she jumps back. “You have to look right! They drive on the other side of the street here!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was crazy,” she says. She points down. “Hey! It says it right there!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indeed, painted on the paved road it says “Look Right” in white.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look right,” she repeats, and we do.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("We walk into a bar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure this is it?” she asks, scanning the room. There are a few groups of travelers eating runny eggs. Flags from different countries line the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I drop my backpack on the ground with an “AHHH” and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_51",
      "title": "51"
    }
  }, [_vm._v("march up to the desk. “Hi,” I say with extra cheer. “We’re checking in.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Check-in is at foh,” the not-so-helpful, pink-haired twentysomething at the registration desk tells us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Foh? “Four?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nods.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But it’s only ten,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nods again. “Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are we supposed to do for six hours?” I ask. My cheer has disappeared. I’m tired. And wet. I need a shower.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dunno.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Will you text us if our room becomes available early?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Give her your cell,” I instruct Leela.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman pretends to write it down. I don’t think we’re going to be hearing from her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m too tired to walk around,” I say. My eyes are heavy. I’m starting to get dizzy. I need sleep. My body is confused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have to get stuff anyway,” Leela says. “Who knows when my bag is coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right,” I say. I turn back to the woman at the desk. “Can I leave my bag here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You could, but it might be safest in your room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I don’t have a room yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nods. “Right. Should be fine. Might be fine. I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just leave it,” Leela says. “It’s locked, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_52",
      "title": "52"
    }
  }, [_vm._v("“Yeah.” But I don’t want to lose mine, too. “I guess I can take it with me. We won’t go too far.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can we eat?” Leela asks. She turns back to the woman at the desk. “Can you recommend a place for brunch?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks at us blankly. “Brunch? No. But you can eat here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t think I want to eat here,” Leela says under her breath. “Any place else? What’s really good?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Freya’s is all right, and it’s just down the road,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And what about shopping? I need shampoo and stuff. My luggage got left in America.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s a Boots on King’s Road,” she says. “And an Haiche-an-em.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Haiche-an-em,” she repeats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“H&M?” Leela asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks at us like we’re morons. “Yeah. Off you go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Okay. I think we were dismissed. “We need to find an ATM too,” I tell Leela. “I only have twenty pounds.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s just eat and then figure it out. I’m starving.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the restaurant, we both order porridge because we think it sounds British, and coffees, which arrive in super tiny cups and are so not going to do the trick.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can I have another one of these, please?” I ask our waiter. “Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Should we call our parents?” Leela asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_53",
      "title": "53"
    }
  }, [_vm._v("“It’s like five in the morning at home,” I say.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My dad told me to call as soon as I could,” she says. “I don’t want him to wake up and get nervous that my plane crashed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go ahead,” I say. “I’m afraid to look at my phone.” I’m going to have to figure out what to do about my data plan, but I’m too tired to deal with it right now. I am worried about my family, but they’re asleep now anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I relax into the chair as she dials.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dad! It’s me. I’m here. No, I’m fine. But they lost my luggage. They’re not sure. Really? Are you sure? How much? Yes, I have it. I’ll let you know. Love you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She hangs up the phone. She’s smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The credit card we got the ticket on has baggage insurance. I can spend five hundred bucks on new things.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Really?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then let’s go spend some pounds.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("“Look at these!” she cries in Boots. She waves a lipstick at me. “British makeup!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It looks a lot like American makeup,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Omigod, they have Nails inc. And the nail polish is only seven pounds. Do you know how much it costs at Sephora? UK makeup shopping spree!” she cheers, admiring a bright red lipstick. “This is like the best thing that has "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_54",
      "title": "54"
    }
  }, [_vm._v("ever happened to me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shouldn’t you buy some clothes too?” I ask. “In case you don’t actually get your luggage?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess,” she says. “But look at this NYX Soft Matte lipstick. I can’t resist it. My lips are going to look so soft! So matte!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe you should also buy some pajamas. And a pair of shorts and a T-shirt. And a bathing suit? Maybe some flip-flops? Or a sweatshirt? It’s chilly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, fine,” she says. “But let me treat you to a lipstick. Or a nail polish? Something?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How about an umbrella?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Done,” she says. “Let’s go get cute matching ones.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I let her buy me a yellow umbrella since the mist outside has turned into a downpour. What if it rains the whole time? What if I’ve spent all my money and deserted my family and I’m miserable the entire four and a half weeks?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No. That’s not going to happen. And my family is fine. Hopefully. I should check on them. No, I can’t. It’s five hours earlier at home so they’re probably still sleeping.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s take a selfie with our umbrellas,” she says on the street corner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stand beside her, and she lifts up her phone. “Smile,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She studies the pic. “You’re smiling with your lips, but not with your eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_55",
      "title": "55"
    }
  }, [_vm._v("“My eyes are tired,” I whine. “So very tired.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One more,” she says, and puts us back in position. Snap. Snap. Snap, snap, snap. “Oh! Look! So cute! So London! I got the umbrellas and the rain and everything. I’m adding the London geofilter. You look adorable.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yay,” I say, although I suspect my voice lacks conviction. “Any texts from the hostel?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nope,” she says. She doesn’t seem so bothered. The shopping spree has reenergized her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At three that afternoon, still roomless, I decide I can finally call home. “Can I borrow your phone?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure,” she says, and hands it to me. “Just dial regularly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I type 1 and then my home phone number.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It rings. Once.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello?” my sister barks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi! It’s me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks for answering all my texts,” my sister says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, I couldn’t. I’m roaming. I’m using Leela’s phone. How’s Mom?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Upstairs. Working.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But is she . . . okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I let out a breath I didn’t know I was holding. “Good. Is it your day off?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great. Did you find the car keys?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_56",
      "title": "56"
    }
  }, [_vm._v("“Did you check the right drawer in the kitchen?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pause. “Oh. Yeah. Here they are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good. Did you take Mom out yesterday?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I took her out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great,” I say. “Can I talk to her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t want to go upstairs,” she says. “Can you call later?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you having fun?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah! Well, I just got here, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In London. Our room isn’t ready yet,” I say. “But Leela lost her luggage and got a credit from AmEx so she gets to spend five hundred bucks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ask her if she wants anything,” Leela says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you want anything?” I ask, my voice suddenly hoarse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A snow globe?” Addison asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I laugh. She used to be obsessed with snow globes. Our dad brought them home for us when he traveled around the country for business. “I’ll get you a London snow globe,” I say. “No, I will get you a snow globe from every city we visit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a lot of snow globes,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I love you "), _c('i', [_vm._v("that")]), _vm._v(" much,” I say. “And I feel incredibly guilty for leaving you with Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s fine! We’ll be fine!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_57",
      "title": "57"
    }
  }, [_vm._v("I bite my lip. “Okay. Good. Love you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She ends the call.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stare at the phone before giving it back, feeling lost. I can’t believe I really left them. My sister is only sixteen! What happens if there’s an emergency? And instead of being there, I’m cold and wet and on the other side of the ocean? What am I doing here?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I need to lie down. “Let’s go check in,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think our room is ready?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It better be.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("By the time we get back to the hostel, I am wiped. Wiped and wet. My bag is wet too. Which means all my clothes are wet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Also our room is on the third floor. I no longer have feeling in my shoulders or back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The clerk types our key code—649—into the lock and motions us in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The room is tiny. There is a single bed against each yellow wall, and a green dresser, a wooden chair, and a tall white fan beside a window. At least the white sheets and pillowcases look clean and bleached. A white towel is folded neatly on the bed. I brought two of my own, one shower and one beach, but I guess it makes sense to use the ones they provide when they provide them. Less laundry. Where are we doing our laundry anyway? I don’t know how to do my own laundry. One advantage to having a mother who doesn’t like to go out "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_58",
      "title": "58"
    }
  }, [_vm._v("is that she spends a lot of time doing laundry.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The wooden window frame has blue curtains and overlooks an alleyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Enjoy,” the woman says, and closes the door behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need to nap,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aren’t we supposed to stay up as late as possible tonight? To get adjusted?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t think I’ll make it,” I say. “Quick nap. Set your phone alarm for five p.m. London time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela lets out a big yawn. “’Kay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pull the curtains closed and plop down on the bed and everything goes dark.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("“Syd, wake up!” Leela says. “It’s eight-fifteen. We have to eat dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mmmmmn,” I murmur, my head stuffed with cotton. I sit up, my head pounding. Where am I? Who am I? What day is it?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She opens the curtains to darkness. I hear laughter from the room next to us. A group of girls, I think. I try to make out some words. “"), _c('i', [_vm._v("Ristorante . . . birra . . . sesso . . .")]), _vm._v("” Italian, maybe?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going to shower,” Leela says. “Then you’re getting up for reals.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pull the sheet over my head and fall back asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("“Your turn,” she says twenty-five minutes later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mmm,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_59",
      "title": "59"
    }
  }, [_vm._v("“Come on, come on,” she says. “I’m starving. Let’s go get some fish and chips.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How’s the shower?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not my best shower. Also, I may have used all the hot water. Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m kidding. There wasn’t any hot water to begin with. Come on. Wear your flip-flops. It’s slimy in there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Going, going,” I say. I get out of bed, even though my limbs feel numb.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I unzip my bag and find my toiletries, and my flip-flops, and wrap my towel around my body.")]), _vm._v(" "), _c('p', {
    staticClass: "int_blsp"
  }, [_vm._v("The shower is three doors down and small. It takes me a few seconds to figure out how to get the water to work, but then it does and it’s effing freezing.")]), _vm._v(" "), _c('p', {
    staticClass: "ext_gudibuk_blsp"
  }, [_c('b', [_vm._v("Tip: When in London you must have the fish and chips.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_sydney_tips"
  }, [_vm._v("Chips are french fries, by the way. And please, for the love of Prince Harry, don’t be a tourist and ask for ketchup.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("“To us,” Leela says, lifting a glass of chardonnay. She only drinks white wine. Red wine stains her teeth, beer burns her mouth, and other drinks, she claims, are gross.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To the drinking age being eighteen!” I say back. I’m drinking a cocktail called a Pimm’s. It’s orangey-brown and tastes fruity and sweet. "), _c('i', [_vm._v("Travel Europe")]), _vm._v(" recommended it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_60",
      "title": "60"
    }
  })]), _c('i', [_vm._v("Travel Europe")]), _vm._v(" also recommended this pub, The Royal Swan, for fish and chips, so here we are. We’re sitting at one of the outside tables. The one-page menu is sticky and covered in plastic, but the food is supposed to be good. We order a plate of fish and chips to share. The fries are pretty amazing. The fish . . . well, they are not frozen fish sticks. More like huge slabs of whitefish fried and then fried some more, and then even more, and one more time for good luck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So what are we doing tomorrow?” Leela asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know. What do you want to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everything,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s see. We definitely want to go to Buckingham Palace.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And we have to go for tea,” Leela says. “At the place my parents got engaged.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hesitate. “Are you sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. Absolutely.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But . . . well, you’re not expecting Matt to show up, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not. Well, a teeny little part of me is, but the rational part of me isn’t. I swear.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe we should skip tea?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. I want to go. It’s part of my story. Screw Matt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, then. We’re going to Selfridges,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s Selfridges?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Isn’t that the tea place where your parents got engaged?” I take another bite of the over-fried fish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_61",
      "title": "61"
    }
  }, [_vm._v("“No. I think that’s a department store. They got engaged at Claridge’s.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh. Sorry. Never mind. Got them confused. To Claridge’s! And maybe tomorrow we should start with the Red Bus tour, so we’ll get the lay of the land.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sounds good. We’ll wake up early and hit the road,” she says. She picks up a chip, aka a french fry. “I really need ketchup.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t be a tourist,” I say. “You’re supposed to eat them with salt and vinegar.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She waves around her. “We’re surrounded by tourists. This restaurant is for tourists. This whole area is for tourists.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fair point,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She waves the waitress over. “Can I have some ketchup, please?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sprinkle the vinegar over the fries and take another bite. “It’s really not bad. Not good. But not terrible.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("Back at the hostel, I spend an hour on hold trying to get through to my phone company. Eventually, I discover that my options are ten bucks per day for unlimited everything or forty bucks per month for a hundred texts and hardly any data. Ten bucks per day is over three hundred dollars. And I’m guessing I would blow through the one hundred texts in about five minutes. They suggest I put it in airplane mode and rely on finding free Wi-Fi, so I can still FaceTime, send iMessages and emails, and use my apps. Luckily the hostel "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_62",
      "title": "62"
    }
  }, [_vm._v("has Wi-Fi. Unluckily, I am once again flooded with messages from Addison:")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Are you really gone for five weeks?")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Where’s the AAA card?")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Never mind I found it.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Mom said she’s not feeling well and doesn’t want to go out.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I write back:")]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Four and a half weeks!")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Great.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Fine today but insist tomorrow, k?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I log in to Gmail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nothing from my mom, but a short email from my dad.")]), _vm._v(" "), _c('p', {
    staticClass: "ext_mail"
  }, [_vm._v("All OK? How was your flight? I’m so proud of you. Have a great trip. Love, Dad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I write him back, telling him I’m fine and thanking him again for the points. Then I type a quick note to my mom telling her I love her and that I hope she feels better tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hope I feel better tomorrow, too. Right now my body feels like I’ve gotten off a seven-hour ride on a Tilt-A-Whirl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come with me to get ready for bed?” Leela asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turn off my phone and follow her to the bathroom.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("“Oops,” I say when I finally open my eyes. It’s two p.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It took us forever to fall asleep. Partly because of our massive nap, partly because I was worrying about my mom and sister, partly because of the time difference, and partly "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_63",
      "title": "63"
    }
  }, [_vm._v("because the people in the next room were up all night partying. Part of me wanted to knock on their door and tell them to be quiet; part of me wanted to knock on their door and ask if we could join. They were clearly having a much better time than we were.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We have to get up,” I say, stepping onto the cold, hard floor. “Red Bus tour, here we come.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think we’re too late,” she says. “We need a full day on it, no?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So what should we do?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eat something?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smile. “Fish and chips?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She groans. “Please no.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We take turns showering and head downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I see a group of girls sitting in the corner, and hear some Italian.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s them,” I say. “The girls from 3B.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hate them,” Leela says. “They kept me up all night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do we hate them?” I ask. “Or do we want to be friends with them? I can’t decide.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a tough call,” Leela agrees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going to say hello,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are?” she says, shocked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s so unlike you,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s the new me,” I say. Leela and I stayed pretty much to ourselves growing up. We had other friends, but were never "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_64",
      "title": "64"
    }
  }, [_vm._v("exactly outgoing. “I had to talk to strangers when you left for school, you know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stand up and walk over to their table. “Hi there,” I say. “Where are you guys from?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They look up and stare.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Roma")]), _vm._v(",” one of them says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, cool,” I say. “We’re going to Rome. We can’t wait. How long are you in London for?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A week,” one says. Then she turns back to her friend and starts speaking in Italian again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stand there for a few minutes waiting to be included or spoken to. But it doesn’t happen. My face burns. All right. At least I tried.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turn around and head back to Leela.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela pats my shoulder. “Bitches,” she mutters. “Who needs them? Let’s get out of here and get some goddamn tea.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("“This place looks fancy,” I say. “I thought going for tea was like going for Starbucks?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Guess not,” Leela says nervously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hope we’re dressed okay.” I’m wearing my jeans and a white T-shirt. Leela is wearing a black sundress and pair of sandals she bought at Haiche-an-em.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s our turn at the hostess’s table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi,” I say. “Can we have a table for two, please?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you have a reservation?” the woman asks. She looks over my jeans and running shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_65",
      "title": "65"
    }
  }, [_vm._v("“No,” I say. “Do I need one?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” she says. “We’re booked for today. Perhaps next week?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll be gone by next week,” Leela says. “Please? Is there any way you could squeeze us in? Please?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re leaving in a few days, and my parents got engaged here. I didn’t know we had to make a reservation. Maybe if someone cancels? Don’t you ever have no-shows?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well . . . There was a cancellation . . .” She looks down at her list, then looks up at us and winks. “I believe I can squeeze you in.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Forty-five minutes later we have a table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is fantastic,” Leela says, admiring the crystal chandeliers, high ceilings, and white tablecloths. “Is this not the most beautiful place you’ve ever seen? Let’s take a picture.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The dishes are all striped white and green. My mother would love them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela takes a selfie of us looking at the menus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Omigod")]), _vm._v(", I think, the prices registering. This is nothing like Starbucks. “Leela. This place is a fortune. This is like my whole sixty bucks in one day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess we’re not getting the champagne?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No! Although I kind of want the champagne. You drink champagne?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course. It’s white wine, isn’t it? So we are getting the champagne?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_66",
      "title": "66"
    }
  }, [_vm._v("“No. We’re not. Don’t be crazy.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At least it’s already four. This is like our breakfast, lunch, and dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It has to be, for this price,” I grumble. “There better be a lot of food. I love you, but we can’t spend fifty-nine pounds on tea. That’s like ninety bucks. That’s insane. Is the tea made of gold?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not just tea. It’s tea sandwiches too. And look! Scones!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The scones do look delicious. But come on. Fifty-nine pounds?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Leela, I’ll stay if you want me to, but . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She sighs and looks around. “He’s really not coming?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She sinks into her chair, defeated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Screw it,” I say. “Let’s do it. What’s fifty-nine pounds in the grand scheme of things?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She smiles, and I can see her dimples.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We order the traditional afternoon tea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It comes in stages.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First come the mini-sandwiches. Omigod. So yummy looking. There are ten of them, spread out on a green-and-white striped plate. Two smoked salmon, two ham, two chicken, two egg, and two cucumber. All are crustless and cut into tiny rectangles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s take a picture,” Leela says, taking out her phone. “Smile!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Snap, snap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_67",
      "title": "67"
    }
  }, [_vm._v("“Posting it,” she says.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We eat them all. I leave the ham ones for Leela since I don’t eat ham. I’m not kosher or anything, but there are certain rules I follow. Bacon yes, ham no. Cheeseburgers yes, burgers with a glass of milk, no. I didn’t go to Hebrew school every Sunday for nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Next come the scones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Smile!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Snap, snap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I spread clotted cream and strawberry jam onto a hot scone. Mmm. I spoon more jam on my bread and take a bite.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A blob of jam drops on my thigh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I take out my napkin and try to rub at the spot, making it worse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’ll come out in the wash,” Leela says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But it’s only day two. And I only packed one pair of jeans. And I’m not sure where we even do our wash.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure your friend Kat has a washing machine,” Leela says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She probably does,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela takes a long sip of tea. “How nice is this apartment going to be?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nice,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the first day of my History of Western Civilization class at the University of Maryland, Katherine Malone sat down next to me and said, “Hey! You’re in my Intro to Sociology class too, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded. Kat had stick-straight light brown hair with "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_68",
      "title": "68"
    }
  }, [_vm._v("blond highlights, pale skin, and light blue eyes. She wore ripped, expensive jeans, diamond stud earrings, and chunky necklaces. She grew up on the Upper East Side in New York City and went to the all-girls school Chapin. All her friends went to UPenn. She hadn’t gotten in. Kat bought expensive Jacques Torres chocolates and liked to share.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kat took terrible notes and talked to everybody. She was in three of my classes and pretty much adopted me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hung out in her dorm between classes and went to parties with her at night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’d even crash at her place once in a while, but I always went home as soon as I could to make sure everyone was okay. I never told Kat why I was going home. I liked keeping College Me separate from Home Me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So what are you doing this summer?” she’d asked as we lay on her dorm bed eating Jacques Torres and studying for finals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Working at Books in Wonderland,” I said. Since it was only three blocks from my house, I had spent a lot of time there as a kid and had started working whenever they were short staffed—partly for the extra money and partly for the 40 percent employee discount.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No vacation?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not this year,” I said, popping another chocolate into my mouth. Mmm. Orange cream. “You?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m interning at some gallery in Paris.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Really?” I asked, almost dropping the chocolate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_69",
      "title": "69"
    }
  }, [_vm._v("“Yup. A friend of my mom’s friend owns it, so off I go!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kat’s mom is a fancy interior designer. Her dad runs a hedge fund. According to a mutual friend, their apartment is an entire floor of a doorman building on Park Avenue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lucky,” I said. A pit of jealousy grew in my stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You should come visit. I have an apartment right near the Latin Quarter—for June, July, and half of August. You can totally stay with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe,” I said, the pit getting bigger. I knew I wouldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But now I actually would.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s so "), _c('i', [_vm._v("nice")]), _vm._v(" for letting us stay at her place,” Leela says now, but her tone is weird. Her tone is always weird when she mentions Kat. Fake pleasant. “How’s your friend, Kat?” she asks, like my mom asking about one of my dad’s new girlfriends. But what did she expect? That she’d go away to school, and I would hole myself up in my house for four years? And anyway, I liked who I was when I was with Kat. I met new people. I went to parties. I broke out of my shell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time we are on our second pot of tea, I am stuffed and wired.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where to next?” Leela asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why don’t we walk around? I need to find an ATM to take out more pounds. Then we can head to Soho for a drink?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s do it,” she says, and I try not to cringe as we pay the bill.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_70",
      "title": "70"
    }
  }, [_vm._v("I stand at the machine, debating how much money to take out. My bank charges a fee for me to withdraw money, so in theory I should take out a lot. But I don’t want to have that much cash on me in case something happens, since hostels aren’t the safest places. Also, I don’t want to get left with too many pounds when we go to Paris, since they use the euro. Hmm.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You okay?” Leela asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yup. One sec.” I decide to take out two hundred pounds. I’m left with only eighteen hundred dollars in my account. That was fast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We spend the next few hours walking around Soho. Leela buys another lipstick, another sundress, shorts, two tank tops, and a sleep shirt that has the London Underground logo on it. She is clearly warming up to the idea of buying new clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We walk into shops, try on necklaces, and take more pictures outside of red phone booths.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look at the two of us,” I say. “Women of the world! Travelers! We’re going to have adventures!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She checks her phone. “One hundred and seventy-five likes for the scones. Pretty much everyone I know except Matt. He hasn’t posted a single picture. Where do you think he is?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know. Maybe he’s at Selfridges.” I smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ha! He’s probably at a pub.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I picture Jackson sitting on a stool, nursing his beer, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_71",
      "title": "71"
    }
  }, [_vm._v("looking around the room for a cute girl. Seeing me. Smiling.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela sighs. “Did I ever tell you that he’s missing one of his pectoral muscles?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Huh? Jackson?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, Matt. He’s missing his left pectoral muscle. He was born without it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does it look weird?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not at all,” she says. “You can barely notice. But he’s so self-conscious about it. He never works out because he thinks if the other one gets big it will be more obvious. But you know what? It’s my favorite part of him. It fits my head perfectly. He’s the best cuddler.” She sighs again. “I miss him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know, sweetie.” I put my arm around her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We pass a small restaurant called Meredith’s Tea Shoppe. The menu says they have high tea for twelve pounds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Next time we eat there,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I feel a drop of water on my forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh no,” she says. “I forgot my umbrella!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have mine,” I say, and pull it out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have a great idea for a picture. Open the umbrella and stand like Mary Poppins.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine, then I’ll do it,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Snap. Post.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks. “I need to reapply my lipstick.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_72",
      "title": "72"
    }
  }, [_vm._v("I have five new messages from Addison when I get back to the hostel.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("OMG I had to take her to the post office today and stand with her the entire time.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("It was ridiculous.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("You do that?")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("For someone who doesn’t drive she is the worst back seat driver ever. She freaked out when I went through a yellow light. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("She’s making me crazy.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I write back to Addison:")]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Yes, I take her to the post office and I stand with her.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("She’s not a back seat driver with me.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("But you just got your license.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("Only four weeks and one day left!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I resist pointing out that I handled Mom’s issues for the last seven years, and she never heard "), _c('i', [_vm._v("me")]), _vm._v(" complain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I also get an email from my mom telling me that I should have fun and that everything is fine. I don’t believe her. I keep seeing her ghostly face as I left the house. I hope she’s not going to get worse. I’m not sure she can get worse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I reply to my mom’s email and send some of the photos I took during the day. I wish I could message her, but my mom doesn’t even have a cell anymore. What’s the point since she hardly ever leaves the house?")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_73",
      "title": "73"
    }
  }, [_vm._v("The next day, amazingly, we make it to the Red Bus tour by nine a.m. The bus is two levels, red, and filled with backpackers and grumpy children with overeager parents. We start off on the roofless top level. It’s cloudy but warm. You can get off at any of the stops, walk around, and then get back on when you’re ready and the next one pulls up. Kind of like a real bus, except these have live guides. Ours is a blond British lady named Bryony, who sounds like she reads a lot of "), _c('i', [_vm._v("Us Weekly")]), _vm._v(" magazines. Or whatever they call it in England. "), _c('i', [_vm._v("UK Weekly")]), _vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is where Duchess Catherine had her hen party!” she tells us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ooooh,” everyone swoons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thomas Crapper lived here! He invented the loo!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think that’s a myth,” Leela says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But it would explain why the toilets in London are so cool. Who needs to see the tank? Not us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is where the Queen buys her knickers!” Bryony tells us a few stops later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can you imagine?” I say. “Now the bus is passing Target, where Sydney Rothstein buys her days of the week undies.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You do not wear days of the week undies,” Leela says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I say. “But I bought them for my sister as a joke. Mondays are blue.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Obviously.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do have polka-dot undies, though. I brought them. They’re super cute.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_74",
      "title": "74"
    }
  }, [_vm._v("A raindrop falls on my guidebook.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Bloody hell,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("We hop off at 11:20, ten minutes before the Changing of the Guard is supposed to begin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Luckily the rain has stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We make our way down the road and toward the crowds and the palace. “Do you think the boys are here?” Leela asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We look around. There are a million people here. “I doubt we’d find them even if they were.” I wouldn’t mind seeing Jackson, to be honest. I wouldn’t sleep with him, but I wouldn’t mind flirting a little.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I can find Matt anywhere. I have perfect Matt-dar. I used to be able to spot him across campus in a group of a thousand. I’m like Edward sniffing out Bella. I’m a vampire. I can smell him in any room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe that’s what the guards change into,” I say. “Vampires. Get it? The changing of the guards?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come on, Sydney. It’s daylight! Don’t be ridiculous. Maybe if the changing of the guards were at night, you’d be on to something.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s actually just the guards changing shifts. If you’re wondering. Thank you, "), _c('i', [_vm._v("Travel Europe")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She pauses. “I wish Matt was posting pictures. Why isn’t he posting? It’s annoying. Wait! I hear something, I hear something!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_75",
      "title": "75"
    }
  }, [_vm._v("Off to the left we see men on black horses. They are wearing red uniforms and strange-looking red helmets.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then from the other side men in red are marching toward us playing instruments. They’re wearing tall black furry hats and remind me of the witch’s guards from "), _c('i', [_vm._v("The Wizard of Oz")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We cross the street and try to get as near as possible to the black iron gates. It seems like something is happening inside. But there are too many people in front of us to see anything. We are all very pressed together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If I were a pickpocket,” I say, “this is where I would come.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everyone around us has selfie sticks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Should I get one of those?” Leela asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please don’t.” I pull out my phone to take pictures and hate that I’m not getting messages. Is my mother okay? What if something horrible really does happen? Would I actually go home? Yes. I promised I would.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you think the guards have changed yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We get up on our tiptoes to try to see. I spot a sleeve of red. I lift my phone, snap a picture, and hope for the best.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("We hop back on the bus and get off again at Mayfair, right by Green Park, to find an emergency bathroom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The bus bumping along is not helping,” Leela says. “My bladder is going to explode. Should we just go into a café?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s go into a hotel,” I say. “Look, there’s the Ritz!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_76",
      "title": "76"
    }
  }, [_vm._v("“You want to just walk into the Ritz to use the bathroom? They’re not going to let us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, they will,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We look like tourists.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who do you think stays at the Ritz? Locals? It’s not like I have my backpack on me. Just walk in like you have a room. Let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When did you get this brave?” she asks, and follows me in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello,” I say to the doorman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“G’day,” he says back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We giggle as we follow the sign to the restroom, pardon me, to the "), _c('i', [_vm._v("loo")]), _vm._v(", down a floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We giggle more as we open the door. It’s all pink. Pink wallpaper, pink sinks, pink floors. Pink everything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is amazing,” she says. “It’s like the Barbie dream house bathroom. Why doesn’t my bathroom look like this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Twenty minutes later—we take our sweet time—we get back on the bus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“From now on, we only use the bathroom at the Ritz,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Deal. I wonder if they have a shower?”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("After a full day of hopping on and hopping off, we end up at an Indian restaurant called Dishoom. The design is retro—checkered floors, posters from the fifties on the wall, marble tables. It reminds me of an über-hip diner. We order chili cheese toast to start, crunchy "), _c('i', [_vm._v("far far")]), _vm._v(" to snack on, and lamb "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_77",
      "title": "77"
    }
  }, [_vm._v("chops to share as our main. Everything is amazing. Leela’s family cooks Indian food sometimes, but mostly rice, daal, and chana masala.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mmm,” Leela says, savoring each bite. “Tomorrow we can go for bagels.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Deal,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What else are we doing tomorrow?” she asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tate Modern, then the Harry Potter platform, then "), _c('i', [_vm._v("Romeo and Juliet")]), _vm._v(" at the Globe, then the Eye.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Romeo and Juliet")]), _vm._v("?” She wrinkles her nose. “I don’t trust that Romeo.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who does?” I ask, eating another bite of lamb.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, fine,” she says. “I’ll see it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good. Cause I already bought the tickets.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are "), _c('i', [_vm._v("so")]), _vm._v(" organized.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Someone has to be.” She hasn’t exactly offered to help with any of the planning yet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela looks embarrassed. “So is the Eye the Ferris wheel?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“More of a cable car. But yes. "), _c('i', [_vm._v("Travel Europe")]), _vm._v(" says it has the best view in London and that we should go at night. It closes at 9:30, though, so we need to get there before then.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sounds like a plan,” she says. “Dishoom selfie?”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("After, we go to a pub in Soho called the Mad Dog and the Drunken Chicken.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Since the stools that line the bar and the booths on the other side of the pub are taken, I squeeze beside a girl and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_78",
      "title": "78"
    }
  }, [_vm._v("order myself a Pimm’s and a glass of chardonnay for Leela.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once our drinks arrive, we stand together and watch people talk to each other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d jump in,” I say, “but I’m scarred from my attempted convo with the Italians.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There’s a television in the corner blasting a soccer game. Red versus blue. A group of guys cheer as someone in blue makes a goal. They look around our age, but they’re wearing suits and white shirts. One has a goatee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Matt likes soccer,” Leela says. “I used to watch games with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nod as she continues to talk about Matt and his love of Toronto FC. I want to be sensitive. I really do. But if she’s going to spend the next four weeks mourning her relationship, I may have to put the earplugs in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“. . . I just can’t believe he’s in the same city as I am, and I don’t know where he is. I hate that. It’s driving me crazy. Maybe you should friend Jackson to see where they are? His account is private.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you want me to,” I say lightly. Then I could look at pictures of him and see if he really is as good-looking as I remember. I take another sip. My head is starting to buzz.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Never mind,” she says. “Too obvious.” She looks back at her phone. “Hey! It’s the fourth of July today! Everyone is posting barbecue pictures! How did we miss that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No one is celebrating America’s independence "), _c('i', [_vm._v("here")]), _vm._v(",” I say. “Since, you know, these are the people we became independent from.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_79",
      "title": "79"
    }
  }, [_vm._v("“Excellent point,” she says.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The boys in suits cheer again. Then there’s a commercial, and then one of them turns around and I see his eye stop on Leela.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My head is starting to feel a bit lighter. “Smile,” I say. “You’re being checked out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am?” She stands up straighter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yup. And do you know what will help you stop thinking about Matt?” I ask over the sound of the crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A snog!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughs. “You want me to kiss a random person?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. I want you to kiss someone. Specifically, the "), _c('i', [_vm._v("bloke")]), _vm._v(" checking you out. Come on. Smile!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She smiles. The guy raises his beer and jumps off his bar stool.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh no,” she says, panicked. “He’s coming over. What do I do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I push her toward him. “You snog him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh God,” she mumbles as he approaches us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You ladies fancy another round?” he asks in an adorable British accent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” I say, finishing off the last of mine. That was "), _c('i', [_vm._v("good")]), _vm._v(". “Thank you. I’m Sydney and this is Leela.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m Charlie,” he says. He’s light-skinned, freckled, and on the short side. “Are you from America?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Guilty as charged,” Leela says, batting her eyes. “Don’t hold it against us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_80",
      "title": "80"
    }
  }, [_vm._v("“Not at all,” he tells her. “I like Americans. You’re so confident and obsessed with our accents. What’s not to like?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We "), _c('i', [_vm._v("are")]), _vm._v(" obsessed with your accents,” Leela admits. “Now say something else.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m so proud of her—she’s talking to him! She’s flirting!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What can I get you to drink?” he asks, overemphasizing his consonants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ohhh,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you visiting London for the summer?” he asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I say. “Just traveling around Europe for a month. London is our first stop.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lucky us,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about you?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I just finished uni and started working in the city,” he says. “So let me spend my first paycheck and buy you ladies a drink. What can I get you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll have another glass of chardonnay,” Leela says. “Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And I’ll have another Pimm’s,” I tell him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Done,” he says, but just then the game returns to the screen, and he snaps his head back to the television.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who’s playing?” I ask him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He doesn’t answer. He just stares at the TV.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello?” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela taps me on the shoulder. “I think he’s forgotten about us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He can’t forget about us,” I say. “He needs to snog you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_81",
      "title": "81"
    }
  }, [_vm._v("“I’m not sure I want to snog him,” Leela whispers. “He’s not even that cute.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Leela,” I say dramatically. “We are in Europe. We’ve been here for "), _c('i', [_vm._v("three")]), _vm._v(" days. We need an adventure. It’s July fourth. We have to celebrate our independence!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We snuck into a bathroom today. Doesn’t that count?” She yawns. “I’m actually getting tired. Can we go?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I say. “First snog, then go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shakes her head. “If you want a snog so badly, you do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine,” I say. “I will.” I let the liquid courage rise up inside me and tap Charlie on the shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hmm?” he says, not even looking at us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Charlie, I need a favor,” I say sweetly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s that?” he asks distractedly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need to snog you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He finally tears his eyes away from the television. “Pardon me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need to have an adventure. And you are it. Would you mind?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela’s jaw is practically on the sticky floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie’s cheeks turn bright red. “I suppose not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Terrific. I’m leaning in.” I can’t believe I’m doing this. Am I really doing this? Yes. I am. I am going to have an adventure. My mother could have a meltdown at any moment and I might need to fly home. I need to have an adventure right "), _c('i', [_vm._v("now")]), _vm._v(". I have to celebrate my independence! I "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_82",
      "title": "82"
    }
  }, [_vm._v("lean toward him, close my eyes, and plant a huge "), _c('i', [_vm._v("snog")]), _vm._v(" right on his mouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His lips are kind of wet. And cold. And squishy. Suddenly he opens his mouth and slides his thin and sour-tasting tongue into my mouth, like a lizard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Omigod, what am I doing? Who is this random guy with his gross tongue in my mouth?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pull back and choke-laugh. “I think that’s enough, thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie looks dazed. “You Yanks really are confident,” he says. “How long did you say you were in London for? Can I see you again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I say. “But it was nice to meet you. Take care.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela laughs as I pull her out of the pub. “Who "), _c('i', [_vm._v("are")]), _vm._v(" you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m the mad dog,” I say, my cheeks on fire. “Which makes you, my friend, the drunken "), _c('i', [_vm._v("chicken")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("At two in the morning, we hear the Italians next door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What are they doing in there?” Leela asks. Then she laughs. “Did you really kiss that random guy at the pub?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, go back to sleep,” I say. I shove in my earplugs, and laugh into my pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("The first part of our day goes as planned. Better than planned. Leela’s duffel arrives with all her things intact. It’s sunny. We can’t find bagels, but we do find buttery toast and jam and American coffees for cheap down the street. Then we take the Tube to the King’s Cross station and find about "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_83",
      "title": "83"
    }
  }, [_vm._v("a hundred people of all different ages and countries, waiting in line for Platform 9¾. After about ninety minutes, it’s finally our turn.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Admit you’re excited,” I say to Leela.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m excited,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Choose your scarf,” a woman in black pants, a red Harry Potter vest, and a black tie tells me. “What house do you belong to?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ravenclaw,” I say. The clever one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman hands me the blue Ravenclaw scarf.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re also kind of a Hufflepuff, don’t you think?” Leela asks. “Hardworking, loyal . . . Although last night you were a total Gryffindor. So brave.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe I’m Divergent,” I say. I pose under the Platform 9¾ sign, point my wand, and smile for Leela’s photo. This one I’m going to post.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("Next we go to the Tate Modern, where many of the paintings look like my sister made them in elementary school, including one large canvas by the bathroom, which is blue. All blue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Seriously?” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have no appreciation for abstract art,” Leela says. She is mesmerized.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Afterward, it’s time for the Globe Theater.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shakespeare and Harry Potter in one day?” I exclaim. “Best. Day. Ever.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re adorable,” Leela says. She still reads books I "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_84",
      "title": "84"
    }
  }, [_vm._v("recommend once in a while, but she’s not the bookworm she used to be.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I reserved us the groundling tickets because they’re only five pounds each and right in front under the open roof. The only problem is that we have to stand the whole time and pray it doesn’t rain. But still. Five pounds each!")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("After the play, which we both ended up loving, although we wished we had splurged on seats, we search for a nearby pub.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t you want to go back to the Mad Dog and the Drunken Chicken to see your boyfriend?” Leela asks gleefully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I say. “I do not. But tonight it’s your turn to snog, got it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll see,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We find a place called The Lion’s Thorny Rose and sit down at a booth. We order two chicken pot pies, a side of chips (aka french fries), plus a Pimm’s for me and a glass of wine for Leela.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why do British pubs all have animals in their names?” Leela asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, last selfie,” Leela says, reapplying her lipstick. “If he wants to see me again he’ll come here. It’s his last chance. He’s leaving tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I roll my eyes. “Are you kidding? Is that why you’ve been posting all these selfies? So he’ll see where we are and come find you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_85",
      "title": "85"
    }
  }, [_vm._v("“No.” She cringes. “Maybe.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But we’re not waiting here all night, are we? I want to go to the Eye. And it closes at nine thirty. It’s supposed to rain tomorrow so it’s better to go today.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know you want to go on the Eye. But we have time, don’t we? It’s still light out. We want to see it in the dark, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. And for the record, you’re hopeless.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me something I don’t know,” she says and lets out an exaggerated sigh. “Now hand me the salt and vinegar. My chips aren’t going to sprinkle themselves.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thirty minutes later, the unthinkable happens.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Matt and Jackson walk through the door of the pub.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I see Jackson first, and all I think as my heart speeds up is, "), _c('i', [_vm._v("Oh! It’s him! Hot Jackson!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then I see Matt. Damn. Matt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t freak out,” I say. “But it’s him. Matt’s here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks simultaneously thrilled and panicked. “He is? Seriously? You’re not taking the piss?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great Briticism,” I say. “But no, he’s really here. He’s looking around the bar.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She sits up straight. “Don’t look. Be subtle. How’s my lipstick?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So soft. So matte.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Great. Is he with Jackson?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.” "), _c('i', [_vm._v("Hellooooo, Jackson")]), _vm._v(". I try to remind myself that he might be hot but he’s also a man whore. Those two should cancel each other out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_86",
      "title": "86"
    }
  }, [_vm._v("Her eyes are wide. “What do I do? Should I act surprised to see him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you surprised to see him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. No. Yes. He’s in London, why wouldn’t he come to see me? He misses me. He knows he messed up. He’s leaving tomorrow. He wasn’t going to just leave the country without seeing me, was he? Without saying good-bye? Where are they now? Look quickly but don’t give us away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I glance sideways out of the corner of my eye.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re sitting at the bar.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Seriously? That’s how he’s going to play it? Like he just happened to come to this random pub?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Travel Europe")]), _vm._v(" did recommend it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Does he look like he’s carrying "), _c('i', [_vm._v("Travel Europe")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. Although he might have the app. An app that you still haven’t downloaded, have you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I tried to,” she says, wincing. “But I forgot my iTunes password.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Very, very casually, Matt spins on his bar stool and faces us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At this point, we’re both looking at him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His mouth makes an O, and his eyes feign surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela gives a little wave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He waves back, still feigning surprise, and he jumps off his stool.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They’re staring at each other. I can feel the pull between them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Omigod. They’re totally going to have sex.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_87",
      "title": "87"
    }
  }, [_vm._v("I look at Jackson, who’s looking at me.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’s still hot. Now he’s wearing a thin gray shirt, faded jeans, and Pumas. He takes a sip of his beer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My heart skips a beat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Man whore. Man whore. Man whore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They both get up and head over to our table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’re coming,” Leela mutters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do we do?” She lifts up a french fry but then puts it back down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you want to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Kill him,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think you want to have sex with him,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ladies,” Matt says, smiling. “Fancy running into you here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, please,” Leela says. She looks up at him. “You totally saw my post.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Post? What’s a post?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leela rolls her eyes. “Ha, ha.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a famous pub,” Matt says. “I wanted to check it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I call bullshit.” She takes a sip of her wine, her eyes not leaving his.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can we join you?” Matt asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She scoots over on her side. Okay, then. We’re doing this. I scoot over on mine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_88",
      "title": "88"
    }
  }, [_vm._v("“So,” I say to Jackson. “How’s your trip?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pretty good,” he says. “Yours?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fantastic,” I say. “Although it’s kind of a bummer none of my ex-boyfriends showed up here too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why not? Don’t they follow Leela’s social feeds?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aha! So that "), _c('i', [_vm._v("is")]), _vm._v(" why you’re here!” Leela calls out, turning toward us. “I knew it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Matt puts his hands up in mock defeat. “You caught me. I wanted to see you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She crosses her arms in front of her chest. “You could have spent the whole trip with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re the one who told me not to come.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re the one who kissed some girl at a bar.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was just a stupid kiss. It didn’t mean anything. I was freaked out. We’re only nineteen, and you were practically picking out our wedding invitations!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was not!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You kept telling me about how your dad proposed!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s because we were going to London!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You look at wedding magazines!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I like the pictures!” she yells. “Don’t make me out to be the messed-up one. We were together all year and you never even said I love you! Why is saying I love you so hard? It’s just three words!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I poke Jackson’s leg under the table, and motion toward the bar. “Drink?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” he says, and the two of us stand up. “We’ll be back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_89",
      "title": "89"
    }
  }, [_vm._v("“So,” I say, balancing myself on a stool. “Are they always like this?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Loud? Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I laugh. “Argumentative.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You live on the same floor at school?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yup.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where are you from again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Vancouver. It’s near Seattle.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know where Vancouver is,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ever been to Canada?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nope.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You came all the way to Europe before visiting your closest neighboring country? Do you have something against Canadians?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re too polite,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not that polite,” he says. “So did you Americans do anything special to celebrate July fourth yesterday?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nope,” I say. “We practically forgot it was happening. It’s easy to get lost in the days here. Did you guys do anything fun?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I got on a plane for Canada Day. It was July first.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You guys have your own day?” I ask, faking shock. “Adorable. Oh no.” I spot Leela and Matt back at the booth. “They’re making out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He spins his chair. “That didn’t take long.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I wanted to go to the Eye,” I pout. “And it’s going "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_90",
      "title": "90"
    }
  }, [_vm._v("to rain tomorrow. It won’t be as good.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you want me to interrupt them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sigh. “No. You’re leaving tomorrow, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. We’re going to Amsterdam.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So tonight is their last night,” I say, nodding to myself. “Yeah, they’re definitely having sex.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Definitely. Those two are like bunnies.” He stands up. “I’ll go with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Huh? “Where?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To the Eye. Didn’t you say you want to go?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My heart races. “You will?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And we just leave them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He laughs. “I’m sure they’ll come up with another activity.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t mind?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do I mind spending my evening going on a Ferris wheel with a hot semi-stranger? No, I don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I blush at the hot part. “I’m not sure if it’s a Ferris wheel exactly. I think it’s more of a cable car.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Works either way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All right, then.” I jump off my stool. “Let’s do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("Leela and Matt could not care less that we’re leaving them to go to the Eye. I’m not entirely sure they even notice. They’re too busy PDAing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s walk,” he says. “I’ve heard the Queen’s Walk is nice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_91",
      "title": "91"
    }
  }, [_vm._v("It is. The paved promenade is lined with trees and metal benches on one side, and beautifully carved lampposts and the winding Thames River on the other.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So,” I repeat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s your story?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What does that mean?” I ask with a laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He smiles. “Boyfriend? Girlfriend?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No and no. You? Girlfriend? Boyfriend?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No and no.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I already got the scoop on you from Leela,” I admit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He winces. “That’s not good. She’s not my biggest fan.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She doesn’t dislike you,” I say. “She just blames you for Matt’s kissing indiscretion. And for convincing Matt that he shouldn’t have a girlfriend. And for all the rain these last few days.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That last one was totally my fault. I have magical weather powers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You do? Amazing! Can you keep it at seventy-five and sunny for the next four weeks? I would so appreciate it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your wish is my command.” He looks at me sideways. “So what else have you heard?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That you’ve slept with the entire freshman class. And possibly the sophomores, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He laughs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“True?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t kiss and tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_92",
      "title": "92"
    }
  }, [_vm._v("I snort. “So it "), _c('i', [_vm._v("is")]), _vm._v(" true.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I like girls,” he says. “But I’m a gentleman. I swear. Scout’s honor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Were you a Boy Scout?” I imagine a smaller, younger version of him with short boyish hair and a rounder face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. Were you a Girl Guide?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Girl Scout. Sorry. It’s called Girl Guides in Canada.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Weird. And for one year. Brownie.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What happened? Couldn’t light a fire without a match?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wasn’t great at the cookie selling,” I say, which is only a partial lie. Girl Scouts require a lot of maternal involvement. A lot. A lot of social maternal involvement. “Although I was really good at eating them. Mmm. Tagalongs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I would totally buy your cookies,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, you would, would you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If your cookies are for sale,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stop and turn to him. “For sale? No, my cookies are not "), _c('i', [_vm._v("for sale")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He turns bright red. “I didn’t mean it like that. Not for sale! I was just getting caught up in the cookie joke and . . .” He shakes his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I laugh. “So you don’t think I’m a prostitute?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I absolutely do not. I am not interested in buying your cookies. Any type of cookies. Even Tagalongs. Or Thin Mints. Especially not the Rah-Rah Raisins.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_93",
      "title": "93"
    }
  }, [_vm._v("The sun is now setting against the river. It’s red and orange and extremely beautiful. I turn back to Jackson.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Want to know a secret?” I say. “"), _c('i', [_vm._v("Nobody")]), _vm._v(" likes the Rah-Rah Raisins.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("By the time we get to the Eye and step inside, the sky is dark and the city is lit up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It really is a cross between a Ferris wheel and a cable car. It’s extremely slow. Like you can’t even tell it’s moving. Most people stand against the glass windows, but there are a few seats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I feel like I’m in the "), _c('i', [_vm._v("Millennium Falcon")]), _vm._v(",” I say. “Doesn’t this look like a spaceship?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It does,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are six other people in our car. A family speaking German and a couple speaking Japanese. As we climb into the sky, the dark river surrounds us. In the distance, I see a lit-up Big Ben.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So Leela told you all about me,” he says, looking over at me. “But all I know about you is that you were a Girl Scout for one year, you like Tagalongs, and you’re not a prostitute. That hardly seems fair. I need more info.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you want to know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He leans closer to me. “Tell me another secret.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A shiver runs down my back. “What kind of secret?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me something most people don’t know about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hmm,” I say, trying to think of something sexy yet "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_94",
      "title": "94"
    }
  }, [_vm._v("entertaining. “When I was in seventh grade, I practiced French kissing on balloons.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He laughs. He has a nice laugh. Low and deep. “Really? Why balloons? Latex turns you on?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I say. “They were just squishy. Your turn. Tell "), _c('i', [_vm._v("me")]), _vm._v(" a secret.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I get turned on by women in latex. Also women in lace. And flannel nightgowns. And—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, I get the picture,” I say. This is not helping with his man-whore reputation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That was three secrets.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“More like one,” I say. As we get higher and higher, the building lights and headlights and streetlights get smaller and smaller until they’re spread out in front of us like glittering stars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Still. Your turn again,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I sent Leela a secret admirer note in the sixth grade. She was sad that I had gotten one and she hadn’t, so I sent one to her and never told her it was from me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Really?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t get excited, I didn’t actually have a crush on her, I just didn’t want her to be sad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I got that,” he says. “That’s sweet. Does she know it was you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. You can never tell her. We spent hours dissecting who could have sent it. Hours. Your turn.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I killed my brother’s frog,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_95",
      "title": "95"
    }
  }, [_vm._v("I gasp and tear my eyes away from the shimmering darkness outside. “What?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“By accident. I promised I would feed it when he went to hockey camp, but I completely forgot about it and it died. My dad checked on it and its eyes were all bugged out and my dad tried to resuscitate it—he’s a doctor—but it did not work. I felt terrible.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s so sad. I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was fifteen years ago. I’m over it. Mostly. Your turn again. Tell me something really important. Something that makes you "), _c('i', [_vm._v("you")]), _vm._v(".” He looks right at me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m not sure why I say it. Maybe because he already turned the conversation sad with his frog comment. Or because at four hundred feet above a foreign city, nothing seems real. Or because even though we’re not alone, no one else in the car seems to speak English. “My mother’s agoraphobic.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He blinks but doesn’t look away. “She won’t leave the house?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shakes his head. “Is she afraid of germs or of something happening? Like a terrorist attack? Is that why she’s afraid to go out?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. That’s not it. She’s more afraid of what "), _c('i', [_vm._v("she’ll")]), _vm._v(" do. She’s afraid she’ll have a panic attack and somehow lose control. And embarrass herself. Or me. She used to be afraid of driving off a cliff by accident, but I think now she just doesn’t want to put herself in any situation where she "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_96",
      "title": "96"
    }
  }, [_vm._v("thinks she might panic.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh. Wow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. She’ll do s"), _c('i', [_vm._v("ome")]), _vm._v(" stuff if she’s with me. Like she’ll sit in the car if I drive. But even with me, she won’t go to a grocery store or a school event or any place that’s packed with people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That sounds hard,” he says, our eyes locked. “For her and for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is,” I say, and take a deep breath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So she’s fine with you leaving the house? She’s not worried about you being so far away?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. Yes.” I shake my head and try to explain. “She’s not afraid of "), _c('i', [_vm._v("me")]), _vm._v(" having panic attacks. But I think she is afraid of me not being there to help her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is your dad around?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nope. They’re divorced. Hopefully my sister, Addison, is taking care of her, but she’s only sixteen. I told her I’d come home if there was a disaster.” I laugh nervously. “So there you go. Now you know what makes me, me. Sorry you asked?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not at all,” he says. “Just sorry you have to go through it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I can’t believe I just told him all that. Leela knows my whole story, but I’ve never even told Kat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our eyes are still locked. Are we having a moment?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I clear my throat. “Your turn. Spill it. What makes you "), _c('i', [_vm._v("you")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He leans in close. “You’re going to be the only one who "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_97",
      "title": "97"
    }
  }, [_vm._v("knows this about me. Are you ready?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smile. “Oh, I’m ready.” I have no idea what he’s going to say, but I’m kind of excited to know what makes him tick.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have to promise to keep it a secret.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I make an X across my chest. “Girl Scout’s honor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He takes a deep breath. “I have never seen any of the "), _c('i', [_vm._v("Star Wars")]), _vm._v(" movies. Not one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now it’s my turn to blink. I thought we were being serious. But I don’t want to show him I’m disappointed. “No way,” I say. “How is that even possible?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I step forward and press my face against the glass.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was actually pretty difficult. Both my brothers are obsessed with them so I had to make a real effort.” Now he’s standing behind me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We’re not touching or anything, but I can feel him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My dad thought I was too young. My brothers saw it and then they bugged me about it, so I started saying I didn’t want to see them anyway. Then it became a matter of principle.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you just pretended to get my "), _c('i', [_vm._v("Star Wars")]), _vm._v(" reference before, huh?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I did. I’m trying to impress you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He steps beside me, so we’re standing side by side against the window, holding on to the railing. His hand brushes against mine and my whole body tingles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neither of us says anything. But he doesn’t move his hand "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_98",
      "title": "98"
    }
  }, [_vm._v("and neither do I. We just stare straight ahead, watching the city rise and fall beneath us.")])]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("“Do you mind stopping at the gift shop?” I ask as we step off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pick up a snow globe that has a teeny tiny London Eye inside. The base is blue, and it says “London” in block letters over a red bus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cute,” he says. “Who’s it for?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My sister,” I say. “I promised her a snow globe from every stop.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s going to be a lot of snow globes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know. That’s why I’m getting the small ones.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How old did you say she was again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sixteen, almost seventeen. Her birthday is on July nineteenth. I gotta do it. It’s part of the bribe.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aren’t you nervous they’ll break?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I cock my head to the side. “I wasn’t before. But it does seem like a fairly likely possibility now that you point it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. I would make sure to wrap them in bubble wrap. Like twelve layers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After it’s packed up into a much larger package than I have room for, we walk across the Golden Jubilee Bridge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m glad we did that,” he says, smiling at me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Me too,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_99",
      "title": "99"
    }
  }, [_vm._v("“Where to now? Should we go to your place or mine?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stop. “Excuse me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He turns bright red. “I didn’t mean that the way it sounded.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I laugh. “How did you mean it exactly?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I meant that Matt and Leela are probably using one of our rooms.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aha,” I say. “But which one? She can’t text me. I can only see iMessages when there’s Wi-Fi.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He pulls out his phone. “They’re in my room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re getting messages?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Canadian plans are better, what can I say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I look over his shoulder to get a peek at the text. It says:")]), _vm._v(" "), _c('p', {
    staticClass: "ext_txt_msg"
  }, [_c('b', [_vm._v("With L. Crash somewhere else.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Subtle,” I say. “Where exactly is he expecting you to sleep?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who knows? I’ll find someplace.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My cheeks heat up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Am I just supposed to invite this not totally random, but somewhat totally random guy to sleep in my hostel room? That does not seem like a good plan. Unless I want to hook up with him. Do I? Sleeping with Jackson would definitely qualify as an adventure. On the other hand, what happens if Leela and Matt get back together and I have to travel with Jackson for the rest of the summer?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shit. Are they getting back together?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What if they want to travel just the two of them for the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_100",
      "title": "100"
    }
  }, [_vm._v("rest of the summer? And Jackson wants nothing to do with me, and I have to travel alone?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe Jackson should interrupt them. No. She’d kill me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Do I even have a choice in this situation?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can come to my hostel,” I say. “We’ll hang out in the bar and see if she comes back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I don’t look at him when I say it. Does he think I mean he can come to my room? I’m not sure. Do I want to hook up with him? I’m not sure. Does he even want to hook up with me?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Back at the bar, I spot the Italians at the corner table. They eye Jackson and then whisper to one another.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ha. I would have introduced you ladies if you hadn’t been such bitches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We sit down at a red vinyl booth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oooh,” he says. “They have ketchup crisps. I’m going to get a bowl. And whatever they have on tap. What about you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pimm’s. It’s my London drink.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the crisps—which I’m pleased to see are actually American chips—come, we both dig in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These are good,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ve never had ketchup crisps?” he asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. We don’t have them in America. Do you have them in Canada?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yup.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I take a sip of my drink. But only a sip, because I don’t "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_101",
      "title": "101"
    }
  }, [_vm._v("want to get drunk and do something stupid like have wild and passionate sex with him.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not that I’m thinking about having wild and passionate sex with him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Or thinking about licking that bit of ketchup powder off his lip. Or off his fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Okay, I totally am.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’s hot. He’s really hot. And he’s mine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not mine, exactly, but sitting at a table with me. The Italians are looking at him. Everyone’s looking at him. He’s tall and has good shoulders and a good laugh and is leaning back in his seat like he owns the place, and I could just crawl onto his lap and wrap my legs around him and—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yeah. No more drinks. I can’t hook up with him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not counting Charlie, I have never kissed, never mind seriously hooked up with, a guy I barely knew.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And the only reason I kissed Charlie was because I knew I would never see him again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If Leela and Matt get back together, I could be seeing "), _c('i', [_vm._v("a lot")]), _vm._v(" of Jackson. I could be traveling with him for the rest of the trip. Hooking up with him seems like a very risky move. A dumb move.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Never mind that he’s a man whore. And I’ve only had sex with two people. Theo and Adam, my good friend from high school. I didn’t like him like "), _c('i', [_vm._v("that")]), _vm._v(", but I knew he had always had a thing for me. I decided to just do it already over winter break our senior year. I trusted him, and we’d had "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_102",
      "title": "102"
    }
  }, [_vm._v("fun. It was nice to feel like I was making someone’s dream come true, even though I’m pretty sure he only got it three quarters of the way in.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am pretty sure Jackson knows how to get it "), _c('i', [_vm._v("all")]), _vm._v(" the way in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Is it getting hot in here?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stuff another crisp into my mouth. Mmm. Good. Ketchupy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Last call,” the barman says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I glance up at the clock. It’s already two a.m.? How did that happen?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t worry about me,” Jackson says. “Go to sleep. I’ll just crash here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In the booth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not sure they’ll let you do that,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then I’ll go back to my hostel. I have to pack soon anyway. We’re leaving in the morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” I say, leaning in. “If I let you crash in Leela’s bed, you’re going to be a perfect gentleman, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course,” he says. “Scout’s honor.”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("“Any chance you have an extra toothbrush?” he asks, looking around our room. It’s a mess. Leela’s clothes and magazines are strewn everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I say. “I figured I could buy an extra one here if I needed. Not so much room in the backpack.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_103",
      "title": "103"
    }
  }, [_vm._v("“A toothbrush is pretty small. Smaller than ten snow globes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, but when you’re trying to accommodate ten snow globes, something’s gotta give.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fair point.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll be back,” I say. “I’m going to brush my teeth. Don’t steal my stuff.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know. Your flip-flops look pretty comfortable.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I’m wearing those to the bathroom,” I say, and slip them on. The bathroom is, thankfully, empty. I pee, wash my hands, brush my teeth, wash my face. I am going for the I-don’t-care-what-I-look-like, I-just-happen-to-be-really-cute look. I hope it’s a good look for me, but I have no idea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I want to make it clear to this guy that I am not putting out. I am not going to be one of his girls. In fact, I am still wearing my bra.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I open the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’s lying on Leela’s bed, the white sheet pulled up to his waist. He is not wearing a shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I look away. Fast. But oh. Those shoulders. Smooth skin. And abs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s hot in here,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can open the window,” I say. “But it gets really loud.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I climb into my bed and pull the sheet up to my neck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He is still shirtless. He is still hot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_104",
      "title": "104"
    }
  }, [_vm._v("I am still wearing my bra. Do I take it off? I want to take it off because it is not comfortable to sleep in a bra and also I only brought four bras with me and can’t really afford to waste one for sleeping. But I can’t just take it off and toss it on a chair, now can I? That would definitely be an invitation. Or at least a waving of a white flag. Beige, in this case.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I can’t let him see my beige bra. It is not cute at all. I turn over on my side so I am staring at the wall. I am never going to be able to fall asleep with a hot shirtless guy a foot away from me. Also I am not going to be able to fall asleep while wearing a bra. Unless I can slip it off and keep it under the covers? I can try. I move very, very slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Twist. Creeeeeak.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My hand is stuck. What is wrong with me? It’s really not that hard. Now a bra strap is wrapped around my neck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("CREEEEEEEEAAAAK.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There. Did it. I’m sweating. Look at me all braless! I’m wild and crazy! Maybe I should hook up with him. Why wouldn’t I? The opportunity has presented itself. There is a super-hot guy in my room. He is a friend of a friend, so he is not a complete stranger. I am in Europe. Isn’t that why I’m here? To have flings with hot guys who happen to be shirtless in my room?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes. Clearly this is an opportunity I should jump on. I should face him. If I face him and he’s looking at me, I’ll give him a sign. I’ll say something frisky like, hey, is it too hot for me to join you?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_105",
      "title": "105"
    }
  }, [_vm._v("Okay. Here we go. I flip onto my back. The bed creaks. I wait.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I look over at him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’s flat on his back. Still shirtless. His left arm is flung over the bed, almost touching the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I think his eyes are closed. Is he really sleeping? How can he sleep at a time like this?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then I hear: “SHHHHHHHLLLLMPH.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Omigod. Is he snoring? I guess he didn’t have as much trouble falling asleep as I did.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“SHLLLLMPHhhhh.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hilarious. I wonder if he stays the night with all the other girls? Have they heard this?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hear laughter from the Italians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“SHLLLLMPHhhhhSHHHHHH.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They better not be laughing at my man. Bitches.")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_vm._v("I hear a key turn in the door. I wake up and see light spilling through the cheap curtains and I twist to look at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s Leela. She’s wearing the same clothes as last night and smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I need coffee. A lot. I think I only fell asleep about fourteen minutes ago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks back and forth between Jackson and me. He’s still asleep. “Did something happen?” she mouths.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shake my head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She mouths something else, but I have no idea what. It "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_106",
      "title": "106"
    }
  }, [_vm._v("looks like "), _c('i', [_vm._v("leather shoe.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She waves me to come with her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I slip my flip-flops back on and follow her into the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He wants me to come to Amsterdam!” she says gleefully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” I say, my heart sinking. It’s happening. Is she going to ditch me? I guess it’s not the end of the world. Maybe she just doesn’t want to stay at Kat’s. I guess I could do Paris by myself and she could go to Amsterdam and we can meet up in Berlin. “Are you going to go?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know,” she says. “Do you want to?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh. Me too?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her eyes widen. “Yes. Both of us. I’m not just going to "), _c('i', [_vm._v("ditch")]), _vm._v(" you. I would never ditch you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I feel a flood of relief. “But we’re supposed to go to Paris. Tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s pouring rain. Didn’t you say it’s supposed to rain all day? Let’s just switch. Let’s go to Amsterdam today. You said nothing was set in stone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I thought you didn’t want to go to Amsterdam. Isn’t he going to be high the whole time?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hopefully not. But even if so, I’d rather be there with him than not. I don’t want my boyfriend getting high and going to prostitutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Prostitutes? Really?” I’ve already spent way too much time on this trip talking about prostitutes. “Wait. Boyfriend?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_107",
      "title": "107"
    }
  }, [_vm._v("She throws her hands up. “I don’t know what’s going on!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I eye her warily. “I’m going to guess you slept together last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course we slept together. But now what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He invited you to go to Amsterdam,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. He said we should both come. Jackson thinks you’re hot.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I flush. “He does? For real?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. Matt texted Jackson to make sure it was cool to invite us and he said yes. You don’t hate him, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I say. “Not at all. We had a good time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Perfect. So can we go? Please? Pretty please?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But what about Paris? What about Berlin?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll just go a few days later. Kat won’t mind, will she?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Probably not,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Isn’t the whole point of traveling through Europe to be spontaneous?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought it was to eat stinky cheeses and gelato and see the "), _c('i', [_vm._v("Mona Lisa")]), _vm._v(" at the Louvre.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pleeeeeeeease?” she begs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I think of the hot half-naked man in my room. “Okay, okay,” I say. “Let me text Kat.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94e56f14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062397096_Chapter_1.vue
// module id = 66
// module chunks = 0